import { c as Re } from "./_commonjsHelpers-2ufMB8rV.js";
var $e = { exports: {} };
/*! For license information please see browser.native.js.LICENSE.txt */
(function(Pe, qe) {
  (function(Ee, pe) {
    Pe.exports = pe();
  })(Re, () => (() => {
    var Ee = { 180: function(ot, K, z) {
      ot.exports = function() {
        var j = function() {
          return j = Object.assign || function(t) {
            for (var e, n = 1, r = arguments.length; n < r; n++)
              for (var i in e = arguments[n])
                Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            return t;
          }, j.apply(this, arguments);
        };
        function I(t) {
          var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
          if (n)
            return n.call(t);
          if (t && typeof t.length == "number")
            return { next: function() {
              return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
            } };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function M(t, e) {
          var n = typeof Symbol == "function" && t[Symbol.iterator];
          if (!n)
            return t;
          var r, i, o = n.call(t), s = [];
          try {
            for (; (e === void 0 || e-- > 0) && !(r = o.next()).done; )
              s.push(r.value);
          } catch (a) {
            i = { error: a };
          } finally {
            try {
              r && !r.done && (n = o.return) && n.call(o);
            } finally {
              if (i)
                throw i.error;
            }
          }
          return s;
        }
        function ft(t, e, n) {
          if (n || arguments.length === 2)
            for (var r, i = 0, o = e.length; i < o; i++)
              !r && i in e || (r || (r = Array.prototype.slice.call(e, 0, i)), r[i] = e[i]);
          return t.concat(r || Array.prototype.slice.call(e));
        }
        typeof SuppressedError == "function" && SuppressedError;
        class W extends Error {
          constructor(e, n, r) {
            super(e), this.token = n, this.type = r || "error";
          }
        }
        const C = (t) => t < 4 ? "short" : t === 4 ? "long" : "narrow", nt = (t) => t % 2 == 0 ? "2-digit" : "numeric";
        function k(t, e) {
          switch (t.width) {
            case 1:
              return "numeric";
            case 2:
              return "2-digit";
            case 3:
              return "short";
            case 4:
              return "long";
            case 5:
              return "narrow";
            default:
              return void e(`${t.desc} is not supported with width ${t.width}`);
          }
        }
        function yt(t, e) {
          const { char: n, desc: r, width: i } = t;
          return n === "d" ? nt(i) : void e(`${r} is not supported`);
        }
        function y(t, e) {
          const { char: n, desc: r, width: i } = t;
          return (n === "c" || n === "e") && i < 3 && e(`Numeric value is not supported for ${r}; falling back to weekday:short`, W.WARNING), C(i);
        }
        function m(t, e) {
          const { char: n, desc: r, width: i } = t;
          switch (n) {
            case "v":
            case "z":
              return i === 4 ? "long" : "short";
            case "V":
              return i === 4 ? "long" : void e(`${r} is not supported with width ${i}`);
            case "X":
              return void e(`${r} is not supported`);
          }
          return "short";
        }
        function w(t, e) {
          switch (t.field) {
            case "era":
              return { era: C(t.width) };
            case "year":
              return function(n, r) {
                switch (n.char) {
                  case "y":
                    return { year: nt(n.width) };
                  case "r":
                    return { calendar: "gregory", year: "numeric" };
                  default:
                    return r(`${n.desc} is not supported; falling back to year:numeric`, W.WARNING), { year: "numeric" };
                }
              }(t, e);
            case "month":
              return { month: k(t, e) };
            case "day":
              return { day: yt(t, e) };
            case "weekday":
              return { weekday: y(t, e) };
            case "period":
              return;
            case "hour":
              return function(n) {
                const r = nt(n.width);
                let i;
                switch (n.char) {
                  case "h":
                    i = "h12";
                    break;
                  case "H":
                    i = "h23";
                    break;
                  case "k":
                    i = "h24";
                    break;
                  case "K":
                    i = "h11";
                }
                return i ? { hour: r, hourCycle: i } : { hour: r };
              }(t);
            case "min":
              return { minute: nt(t.width) };
            case "sec":
              return { second: nt(t.width) };
            case "tz":
              return { timeZoneName: m(t, e) };
            case "quarter":
            case "week":
            case "sec-frac":
            case "ms":
              e(`${t.desc} is not supported`);
          }
        }
        function g(t) {
          let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (i) => {
            throw i;
          };
          const n = {}, r = [];
          for (const i of t) {
            const { error: o, field: s, str: a } = i;
            if (o) {
              const f = new W(o.message, i);
              f.stack = o.stack, e(f);
            }
            a && e(new W(`Ignoring string part: ${a}`, i, W.WARNING)), s && (r.indexOf(s) === -1 ? r.push(s) : e(new W(`Duplicate ${s} token`, i)));
            const c = w(i, (f, x) => e(new W(f, i, x)));
            c && Object.assign(n, c);
          }
          return n;
        }
        const E = { G: { field: "era", desc: "Era" }, y: { field: "year", desc: "Year" }, Y: { field: "year", desc: 'Year of "Week of Year"' }, u: { field: "year", desc: "Extended year" }, U: { field: "year", desc: "Cyclic year name" }, r: { field: "year", desc: "Related Gregorian year" }, Q: { field: "quarter", desc: "Quarter" }, q: { field: "quarter", desc: "Stand-alone quarter" }, M: { field: "month", desc: "Month in year" }, L: { field: "month", desc: "Stand-alone month in year" }, w: { field: "week", desc: "Week of year" }, W: { field: "week", desc: "Week of month" }, d: { field: "day", desc: "Day in month" }, D: { field: "day", desc: "Day of year" }, F: { field: "day", desc: "Day of week in month" }, g: { field: "day", desc: "Modified julian day" }, E: { field: "weekday", desc: "Day of week" }, e: { field: "weekday", desc: "Local day of week" }, c: { field: "weekday", desc: "Stand-alone local day of week" }, a: { field: "period", desc: "AM/PM marker" }, b: { field: "period", desc: "AM/PM/noon/midnight marker" }, B: { field: "period", desc: "Flexible day period" }, h: { field: "hour", desc: "Hour in AM/PM (1~12)" }, H: { field: "hour", desc: "Hour in day (0~23)" }, k: { field: "hour", desc: "Hour in day (1~24)" }, K: { field: "hour", desc: "Hour in AM/PM (0~11)" }, j: { field: "hour", desc: "Hour in preferred cycle" }, J: { field: "hour", desc: "Hour in preferred cycle without marker" }, C: { field: "hour", desc: "Hour in preferred cycle with flexible marker" }, m: { field: "min", desc: "Minute in hour" }, s: { field: "sec", desc: "Second in minute" }, S: { field: "sec-frac", desc: "Fractional second" }, A: { field: "ms", desc: "Milliseconds in day" }, z: { field: "tz", desc: "Time Zone: specific non-location" }, Z: { field: "tz", desc: "Time Zone" }, O: { field: "tz", desc: "Time Zone: localized" }, v: { field: "tz", desc: "Time Zone: generic non-location" }, V: { field: "tz", desc: "Time Zone: ID" }, X: { field: "tz", desc: "Time Zone: ISO8601 with Z" }, x: { field: "tz", desc: "Time Zone: ISO8601" } }, dt = (t) => t >= "A" && t <= "Z" || t >= "a" && t <= "z";
        function mt(t, e) {
          const n = t[e];
          if (!n)
            return null;
          if (dt(n))
            return function(o, s) {
              const a = o[s];
              let c = 1;
              for (; o[++s] === a; )
                ++c;
              const f = E[a];
              return f ? { char: a, field: f.field, desc: f.desc, width: c } : { char: a, error: new Error(`The letter ${a} is not a valid field identifier`), width: c };
            }(t, e);
          if (n === "'")
            return function(o, s) {
              let a = o[++s], c = 2;
              if (a === "'")
                return { char: "'", str: a, width: c };
              for (; ; ) {
                const f = o[++s];
                if (++c, f === void 0)
                  return { char: "'", error: new Error(`Unterminated quoted literal in pattern: ${a || o}`), str: a, width: c };
                if (f === "'") {
                  if (o[++s] !== "'")
                    return { char: "'", str: a, width: c };
                  ++c;
                }
                a += f;
              }
            }(t, e);
          let r = n, i = 1;
          for (; ; ) {
            const o = t[++e];
            if (!o || dt(o) || o === "'")
              return { char: n, str: r, width: i };
            r += o, i += 1;
          }
        }
        function U(t) {
          const e = [];
          let n = 0;
          for (; ; ) {
            const r = mt(t, n);
            if (!r)
              return e;
            e.push(r), n += r.width;
          }
        }
        class tt extends Error {
          constructor(e, n) {
            super(n), this.code = e;
          }
        }
        class Lt extends tt {
          constructor(e, n) {
            super("BAD_OPTION", `Unknown ${e} option: ${n}`), this.stem = e, this.option = n;
          }
        }
        class ee extends tt {
          constructor(e) {
            super("BAD_STEM", `Unknown stem: ${e}`), this.stem = e;
          }
        }
        class Rt extends tt {
          constructor(e, n) {
            super("MASKED_VALUE", `Value for ${e} is set multiple times`), this.type = e, this.prev = n;
          }
        }
        class zt extends tt {
          constructor(e) {
            super("MISSING_OPTION", `Required option missing for ${e}`), this.stem = e;
          }
        }
        class qt extends tt {
          constructor(e, n) {
            super("BAD_PATTERN", n), this.char = e;
          }
        }
        class Ft extends tt {
          constructor(e, n, r) {
            super("TOO_MANY_OPTIONS", `Token ${e} only supports ${r > 1 ? `${r} options` : "one option"} (got ${n.length})`), this.stem = e, this.options = n;
          }
        }
        class Pt extends tt {
          constructor(e, n) {
            super("UNSUPPORTED", `The stem ${e} is not supported`), this.stem = e, n && (this.message += ` with value ${n}`, this.source = n);
          }
        }
        function Et(t, e) {
          let { numberingSystem: n } = e;
          return Array.isArray(t) || (t = [t]), n ? t.map((r) => {
            const i = r.indexOf("-u-") === -1 ? "u-nu" : "nu";
            return `${r}-${i}-${n}`;
          }).concat(t) : t;
        }
        function oe(t) {
          let { scale: e, unit: n } = t, r = typeof e == "number" && e >= 0 ? e : 1;
          return n && n.style === "percent" && (r *= 0.01), r;
        }
        function Zt(t, e) {
          const { decimal: n, group: r, integerWidth: i, notation: o, precision: s, roundingMode: a, sign: c, unit: f, unitPer: x, unitWidth: $ } = t, P = (q, lt) => {
            e && e(new Pt(q, lt));
          }, b = {};
          if (f)
            switch (f.style) {
              case "base-unit":
                b.style = "decimal";
                break;
              case "currency":
                b.style = "currency", b.currency = f.currency;
                break;
              case "measure-unit":
                b.style = "unit", b.unit = f.unit.replace(/.*-/, ""), x && (b.unit += "-per-" + x.replace(/.*-/, ""));
                break;
              case "percent":
                b.style = "percent";
                break;
              case "permille":
                P("permille");
            }
          switch ($) {
            case "unit-width-full-name":
              b.currencyDisplay = "name", b.unitDisplay = "long";
              break;
            case "unit-width-hidden":
              P($);
              break;
            case "unit-width-iso-code":
              b.currencyDisplay = "code";
              break;
            case "unit-width-narrow":
              b.currencyDisplay = "narrowSymbol", b.unitDisplay = "narrow";
              break;
            case "unit-width-short":
              b.currencyDisplay = "symbol", b.unitDisplay = "short";
          }
          switch (r) {
            case "group-off":
              b.useGrouping = !1;
              break;
            case "group-auto":
              b.useGrouping = !0;
              break;
            case "group-min2":
            case "group-on-aligned":
            case "group-thousands":
              P(r), b.useGrouping = !0;
          }
          if (s)
            switch (s.style) {
              case "precision-fraction": {
                const { minFraction: q, maxFraction: lt, minSignificant: ut, maxSignificant: Y, source: jt } = s;
                typeof q == "number" && (b.minimumFractionDigits = q, typeof ut == "number" && P("precision-fraction", jt)), typeof lt == "number" && (b.maximumFractionDigits = lt), typeof ut == "number" && (b.minimumSignificantDigits = ut), typeof Y == "number" && (b.maximumSignificantDigits = Y);
                break;
              }
              case "precision-integer":
                b.maximumFractionDigits = 0;
                break;
              case "precision-unlimited":
                b.maximumFractionDigits = 20;
                break;
              case "precision-increment":
                break;
              case "precision-currency-standard":
                b.trailingZeroDisplay = s.trailingZero;
                break;
              case "precision-currency-cash":
                P(s.style);
            }
          if (o)
            switch (o.style) {
              case "compact-short":
                b.notation = "compact", b.compactDisplay = "short";
                break;
              case "compact-long":
                b.notation = "compact", b.compactDisplay = "long";
                break;
              case "notation-simple":
                b.notation = "standard";
                break;
              case "scientific":
              case "engineering": {
                const { expDigits: q, expSign: lt, source: ut, style: Y } = o;
                b.notation = Y, (q && q > 1 || lt && lt !== "sign-auto") && P(Y, ut);
                break;
              }
            }
          if (i) {
            const { min: q, max: lt, source: ut } = i;
            if (q > 0 && (b.minimumIntegerDigits = q), Number(lt) > 0) {
              const Y = b.notation === "engineering" || b.notation === "scientific";
              lt === 3 && Y ? b.notation = "engineering" : P("integer-width", ut);
            }
          }
          switch (c) {
            case "sign-auto":
              b.signDisplay = "auto";
              break;
            case "sign-always":
              b.signDisplay = "always";
              break;
            case "sign-except-zero":
              b.signDisplay = "exceptZero";
              break;
            case "sign-never":
              b.signDisplay = "never";
              break;
            case "sign-accounting":
              b.currencySign = "accounting";
              break;
            case "sign-accounting-always":
              b.currencySign = "accounting", b.signDisplay = "always";
              break;
            case "sign-accounting-except-zero":
              b.currencySign = "accounting", b.signDisplay = "exceptZero";
          }
          return n === "decimal-always" && P(n), a && P(a), b;
        }
        function h(t, e, n) {
          const r = t[e];
          switch (r) {
            case "%":
              return { char: "%", style: "percent", width: 1 };
            case "‰":
              return { char: "%", style: "permille", width: 1 };
            case "¤": {
              let i = 1;
              for (; t[++e] === "¤"; )
                ++i;
              switch (i) {
                case 1:
                  return { char: r, currency: "default", width: i };
                case 2:
                  return { char: r, currency: "iso-code", width: i };
                case 3:
                  return { char: r, currency: "full-name", width: i };
                case 5:
                  return { char: r, currency: "narrow", width: i };
                default:
                  return n(new qt("¤", `Invalid number (${i}) of ¤ chars in pattern`)), null;
              }
            }
            case "*": {
              const i = t[e + 1];
              if (i)
                return { char: r, pad: i, width: 2 };
              break;
            }
            case "+":
            case "-":
              return { char: r, width: 1 };
            case "'": {
              let i = t[++e], o = 2;
              if (i === "'")
                return { char: r, str: i, width: o };
              for (; ; ) {
                const s = t[++e];
                if (++o, s === void 0)
                  return n(new qt("'", `Unterminated quoted literal in pattern: ${i}`)), { char: r, str: i, width: o };
                if (s === "'") {
                  if (t[++e] !== "'")
                    return { char: r, str: i, width: o };
                  ++o;
                }
                i += s;
              }
            }
          }
          return null;
        }
        const _ = (t) => t >= "0" && t <= "9";
        function V(t, e) {
          const n = t[e];
          if (_(n)) {
            let r = n;
            for (; ; ) {
              const i = t[++e];
              if (!_(i))
                return { char: "0", digits: r, width: r.length };
              r += i;
            }
          }
          switch (n) {
            case "#": {
              let r = 1;
              for (; t[++e] === "#"; )
                ++r;
              return { char: n, width: r };
            }
            case "@": {
              let r = 1;
              for (; t[++e] === "@"; )
                ++r;
              let i = r;
              for (e -= 1; t[++e] === "#"; )
                ++i;
              return { char: n, min: r, width: i };
            }
            case "E": {
              const r = t[e + 1] === "+";
              r && ++e;
              let i = 0;
              for (; t[++e] === "0"; )
                ++i;
              if (i)
                return { char: n, expDigits: i, plus: r, width: (r ? 2 : 1) + i };
              break;
            }
            case ".":
            case ",":
              return { char: n, width: 1 };
          }
          return null;
        }
        function bt(t, e, n) {
          let r;
          (function(f) {
            f[f.Prefix = 0] = "Prefix", f[f.Number = 1] = "Number", f[f.Suffix = 2] = "Suffix";
          })(r || (r = {}));
          const i = [], o = [], s = [];
          let a = r.Prefix, c = "";
          for (; e < t.length; ) {
            const f = t[e];
            if (f === ";") {
              e += 1;
              break;
            }
            switch (a) {
              case r.Prefix: {
                const x = h(t, e, n);
                if (x)
                  c && (i.push({ char: "'", str: c, width: c.length }), c = ""), i.push(x), e += x.width;
                else {
                  const $ = V(t, e);
                  $ ? (c && (i.push({ char: "'", str: c, width: c.length }), c = ""), a = r.Number, o.push($), e += $.width) : (c += f, e += 1);
                }
                break;
              }
              case r.Number: {
                const x = V(t, e);
                x ? (o.push(x), e += x.width) : a = r.Suffix;
                break;
              }
              case r.Suffix: {
                const x = h(t, e, n);
                x ? (c && (s.push({ char: "'", str: c, width: c.length }), c = ""), s.push(x), e += x.width) : (c += f, e += 1);
                break;
              }
            }
          }
          return c && s.push({ char: "'", str: c, width: c.length }), { pattern: { prefix: i, number: o, suffix: s }, pos: e };
        }
        function st(t, e, n, r, i) {
          let o = !1, s = "";
          for (const a of t)
            switch (a.char) {
              case "%":
                e.unit = { style: a.style }, i ? o = !0 : s = "";
                break;
              case "¤":
                if (!n) {
                  r(new qt("¤", "The ¤ pattern requires a currency"));
                  break;
                }
                switch (e.unit = { style: "currency", currency: n }, a.currency) {
                  case "iso-code":
                    e.unitWidth = "unit-width-iso-code";
                    break;
                  case "full-name":
                    e.unitWidth = "unit-width-full-name";
                    break;
                  case "narrow":
                    e.unitWidth = "unit-width-narrow";
                }
                i ? o = !0 : s = "";
                break;
              case "*":
                break;
              case "+":
                o || (s += "+");
                break;
              case "'":
                o || (s += a.str);
            }
          return s;
        }
        function X(t, e) {
          let n = !1, r = "";
          for (const i of t)
            switch (i.char) {
              case "%":
              case "¤":
                e ? n = !0 : r = "";
                break;
              case "-":
                n || (r += "-");
                break;
              case "'":
                n || (r += i.str);
            }
          return r;
        }
        function Wt(t, e) {
          let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (c) => {
            throw c;
          };
          const { tokens: r, negative: i } = function(c, f) {
            const { pattern: x, pos: $ } = bt(c, 0, f);
            if ($ < c.length) {
              const { pattern: P } = bt(c, $, f);
              return { tokens: x, negative: P };
            }
            return { tokens: x };
          }(t, n), o = function(c, f) {
            const x = {};
            let $ = !1, P = !1, b = 0, q = "", lt = -1, ut = "", Y = 0;
            for (let St = 0; St < c.length; ++St) {
              const kt = c[St];
              switch (kt.char) {
                case "#":
                  lt === -1 ? (q && f(new qt("#", "Pattern has # after integer digits")), b += kt.width) : Y += kt.width;
                  break;
                case "0":
                  lt === -1 ? q += kt.digits : (Y && f(new qt("0", "Pattern has digits after # in fraction")), ut += kt.digits);
                  break;
                case "@":
                  x.precision && f(new Rt("precision", x.precision)), x.precision = { style: "precision-fraction", minSignificant: kt.min, maxSignificant: kt.width };
                  break;
                case ",":
                  $ = !0;
                  break;
                case ".":
                  lt === 1 && f(new qt(".", "Pattern has more than one decimal separator")), lt = St;
                  break;
                case "E":
                  P && f(new Rt("exponent", x.notation)), $ && f(new qt("E", "Exponential patterns may not contain grouping separators")), x.notation = { style: "scientific" }, kt.expDigits > 1 && (x.notation.expDigits = kt.expDigits), kt.plus && (x.notation.expSign = "sign-always"), P = !0;
              }
            }
            $ ? x.group = "group-auto" : b + q.length > 3 && (x.group = "group-off");
            const jt = +`${q || "0"}.${ut}`;
            if (jt && (x.precision = { style: "precision-increment", increment: jt }), P)
              if (x.precision && !jt || (x.integerWidth = b ? { min: 1, max: b + q.length } : { min: Math.max(1, q.length) }), x.precision)
                jt || (x.integerWidth = { min: 1, max: 1 });
              else {
                const St = q.length + ut.length;
                lt === -1 ? St > 0 && (x.precision = { style: "precision-fraction", maxSignificant: St }) : (x.precision = { style: "precision-fraction", maxSignificant: Math.max(1, St) + Y }, St > 1 && (x.precision.minSignificant = St));
              }
            else
              q.length > 1 && (x.integerWidth = { min: q.length }), x.precision || !ut.length && !Y || (x.precision = { style: "precision-fraction", minFraction: ut.length, maxFraction: ut.length + Y });
            return x;
          }(r.number, n), s = st(r.prefix, o, e, n, !0), a = st(r.suffix, o, e, n, !1);
          if (i) {
            const c = X(i.prefix, !0), f = X(i.suffix, !1);
            o.affix = { pos: [s, a], neg: [c, f] }, o.sign = "sign-never";
          } else
            (s || a) && (o.affix = { pos: [s, a] });
          return o;
        }
        function vt(t) {
          const [e] = t.split("-", 1);
          return ["acceleration", "angle", "area", "concentr", "consumption", "digital", "duration", "electric", "energy", "force", "frequency", "graphics", "length", "light", "mass", "power", "pressure", "speed", "temperature", "torque", "volume"].indexOf(e) !== -1;
        }
        const Mt = { "compact-short": 0, "compact-long": 0, "notation-simple": 0, scientific: 2, engineering: 2, percent: 0, permille: 0, "base-unit": 0, currency: 1, "measure-unit": 1, "per-measure-unit": 1, "unit-width-narrow": 0, "unit-width-short": 0, "unit-width-full-name": 0, "unit-width-iso-code": 0, "unit-width-hidden": 0, "precision-integer": 0, "precision-unlimited": 0, "precision-currency-standard": 1, "precision-currency-cash": 0, "precision-increment": 1, "rounding-mode-ceiling": 0, "rounding-mode-floor": 0, "rounding-mode-down": 0, "rounding-mode-up": 0, "rounding-mode-half-even": 0, "rounding-mode-half-down": 0, "rounding-mode-half-up": 0, "rounding-mode-unnecessary": 0, "integer-width": 1, scale: 1, "group-off": 0, "group-min2": 0, "group-auto": 0, "group-on-aligned": 0, "group-thousands": 0, latin: 0, "numbering-system": 1, "sign-auto": 0, "sign-always": 0, "sign-never": 0, "sign-accounting": 0, "sign-accounting-always": 0, "sign-except-zero": 0, "sign-accounting-except-zero": 0, "decimal-auto": 0, "decimal-always": 0 }, re = { currency: 1, "integer-width": 1, "measure-unit": 1, "numbering-system": 1, "per-measure-unit": 1, "precision-increment": 1, scale: 1 };
        function ue(t, e, n) {
          if (function(r) {
            return r in Mt;
          }(t)) {
            const r = Mt[t];
            if (e.length > r) {
              if (r === 0)
                for (const i of e)
                  n(new Lt(t, i));
              else
                n(new Ft(t, e, r));
              return !1;
            }
            if (function(i) {
              return i in re;
            }(t) && e.length < re[t])
              return n(new zt(t)), !1;
          }
          return !0;
        }
        function Dt(t, e) {
          const n = e === "fraction" ? /^\.(0*)(\+|#*)$/ : /^(@+)(\+|#*)$/, r = t && t.match(n);
          if (r) {
            const i = r[1].length;
            switch (r[2].charAt(0)) {
              case "":
                return { min: i, max: i };
              case "+":
                return { min: i, max: null };
              case "#":
                return { min: i, max: i + r[2].length };
            }
          }
          return null;
        }
        class ae {
          constructor(e) {
            this.skeleton = {}, this.onError = e;
          }
          badOption(e, n) {
            this.onError(new Lt(e, n));
          }
          assertEmpty(e) {
            const n = this.skeleton[e];
            n && this.onError(new Rt(e, n));
          }
          parseToken(e, n) {
            if (!ue(e, n, this.onError))
              return;
            const r = n[0], i = this.skeleton;
            switch (e) {
              case "compact-short":
              case "compact-long":
              case "notation-simple":
                this.assertEmpty("notation"), i.notation = { style: e };
                break;
              case "scientific":
              case "engineering": {
                let o, s = null;
                for (const c of n)
                  switch (c) {
                    case "sign-auto":
                    case "sign-always":
                    case "sign-never":
                    case "sign-accounting":
                    case "sign-accounting-always":
                    case "sign-except-zero":
                    case "sign-accounting-except-zero":
                      o = c;
                      break;
                    default:
                      /^\+e+$/.test(c) ? s = c.length - 1 : this.badOption(e, c);
                  }
                this.assertEmpty("notation");
                const a = n.join("/");
                i.notation = s && o ? { style: e, source: a, expDigits: s, expSign: o } : s ? { style: e, source: a, expDigits: s } : o ? { style: e, source: a, expSign: o } : { style: e, source: a };
                break;
              }
              case "percent":
              case "permille":
              case "base-unit":
                this.assertEmpty("unit"), i.unit = { style: e };
                break;
              case "currency":
                /^[A-Z]{3}$/.test(r) ? (this.assertEmpty("unit"), i.unit = { style: e, currency: r }) : this.badOption(e, r);
                break;
              case "measure-unit":
                vt(r) ? (this.assertEmpty("unit"), i.unit = { style: e, unit: r }) : this.badOption(e, r);
                break;
              case "per-measure-unit":
                vt(r) ? (this.assertEmpty("unitPer"), i.unitPer = r) : this.badOption(e, r);
                break;
              case "unit-width-narrow":
              case "unit-width-short":
              case "unit-width-full-name":
              case "unit-width-iso-code":
              case "unit-width-hidden":
                this.assertEmpty("unitWidth"), i.unitWidth = e;
                break;
              case "precision-integer":
              case "precision-unlimited":
              case "precision-currency-cash":
                this.assertEmpty("precision"), i.precision = { style: e };
                break;
              case "precision-currency-standard":
                this.assertEmpty("precision"), i.precision = r === "w" ? { style: e, trailingZero: "stripIfInteger" } : { style: e };
                break;
              case "precision-increment": {
                const o = Number(r);
                o > 0 ? (this.assertEmpty("precision"), i.precision = { style: e, increment: o }) : this.badOption(e, r);
                break;
              }
              case "rounding-mode-ceiling":
              case "rounding-mode-floor":
              case "rounding-mode-down":
              case "rounding-mode-up":
              case "rounding-mode-half-even":
              case "rounding-mode-half-odd":
              case "rounding-mode-half-ceiling":
              case "rounding-mode-half-floor":
              case "rounding-mode-half-down":
              case "rounding-mode-half-up":
              case "rounding-mode-unnecessary":
                this.assertEmpty("roundingMode"), i.roundingMode = e;
                break;
              case "integer-width":
                if (/^\+0*$/.test(r))
                  this.assertEmpty("integerWidth"), i.integerWidth = { source: r, min: r.length - 1 };
                else {
                  const o = r.match(/^#*(0*)$/);
                  o ? (this.assertEmpty("integerWidth"), i.integerWidth = { source: r, min: o[1].length, max: o[0].length }) : this.badOption(e, r);
                }
                break;
              case "scale": {
                const o = Number(r);
                o > 0 ? (this.assertEmpty("scale"), i.scale = o) : this.badOption(e, r);
                break;
              }
              case "group-off":
              case "group-min2":
              case "group-auto":
              case "group-on-aligned":
              case "group-thousands":
                this.assertEmpty("group"), i.group = e;
                break;
              case "latin":
                this.assertEmpty("numberingSystem"), i.numberingSystem = "latn";
                break;
              case "numbering-system":
                ["arab", "arabext", "bali", "beng", "deva", "fullwide", "gujr", "guru", "hanidec", "khmr", "knda", "laoo", "latn", "limb", "mlym", "mong", "mymr", "orya", "tamldec", "telu", "thai", "tibt"].indexOf(r) !== -1 ? (this.assertEmpty("numberingSystem"), i.numberingSystem = r) : this.badOption(e, r);
                break;
              case "sign-auto":
              case "sign-always":
              case "sign-never":
              case "sign-accounting":
              case "sign-accounting-always":
              case "sign-except-zero":
              case "sign-accounting-except-zero":
                this.assertEmpty("sign"), i.sign = e;
                break;
              case "decimal-auto":
              case "decimal-always":
                this.assertEmpty("decimal"), i.decimal = e;
                break;
              default: {
                const o = function(s, a, c) {
                  const f = Dt(s, "fraction");
                  if (f) {
                    a.length > 1 && c(new Ft(s, a, 1));
                    const $ = { style: "precision-fraction", source: s, minFraction: f.min };
                    f.max != null && ($.maxFraction = f.max);
                    const P = a[0], b = Dt(P, "significant");
                    return b ? ($.source = `${s}/${P}`, $.minSignificant = b.min, b.max != null && ($.maxSignificant = b.max)) : P && c(new Lt(s, P)), $;
                  }
                  const x = Dt(s, "significant");
                  if (x) {
                    for (const P of a)
                      c(new Lt(s, P));
                    const $ = { style: "precision-fraction", source: s, minSignificant: x.min };
                    return x.max != null && ($.maxSignificant = x.max), $;
                  }
                  return null;
                }(e, n, this.onError);
                o ? (this.assertEmpty("precision"), i.precision = o) : this.onError(new ee(e));
              }
            }
          }
        }
        function F(t) {
          let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (i) => {
            throw i;
          };
          const n = [];
          for (const i of t.split(" "))
            if (i) {
              const o = i.split("/"), s = o.shift() || "";
              n.push({ stem: s, options: o });
            }
          const r = new ae(e);
          for (const { stem: i, options: o } of n)
            r.parseToken(i, o);
          return r.skeleton;
        }
        function l(t, e, n, r) {
          typeof e == "string" && (e = e.indexOf("::") === 0 ? F(e.slice(2), r) : Wt(e, n, r));
          const i = Et(t, e), o = Zt(e, r), s = function(c) {
            const f = oe(c), { precision: x } = c;
            return x && x.style === "precision-increment" ? ($) => function(P, b) {
              const q = +P + b / 2;
              return q - q % +b;
            }($, x.increment) * f : ($) => $ * f;
          }(e), a = new Intl.NumberFormat(i, o);
          if (e.affix) {
            const [c, f] = e.affix.pos, [x, $] = e.affix.neg || ["", ""];
            return (P) => {
              const b = a.format(s(P));
              return P < 0 ? `${x}${b}${$}` : `${c}${b}${f}`;
            };
          }
          return (c) => a.format(s(c));
        }
        function v(t, e, n, r) {
          typeof e == "string" && (e = e.indexOf("::") === 0 ? F(e.slice(2), r) : Wt(e, n, r));
          const i = Et(t, e), o = Zt(e, r), s = function(f) {
            const x = oe(f), { precision: $ } = f;
            if ($ && $.style === "precision-increment") {
              const P = "+n + " + $.increment / 2;
              let b = `x - (x % +${$.increment})`;
              return x !== 1 && (b = `(${b}) * ${x}`), `function(n) { var x = ${P}; return ${b}; }`;
            }
            return x !== 1 ? `function(n) { return n * ${x}; }` : null;
          }(e), a = ["(function() {", `var opt = ${JSON.stringify(o)};`, `var nf = new Intl.NumberFormat(${JSON.stringify(i)}, opt);`];
          let c = "nf.format(value)";
          if (s && (a.push(`var mod = ${s};`), c = "nf.format(mod(value))"), e.affix) {
            const [f, x] = e.affix.pos.map(($) => JSON.stringify($));
            if (e.affix.neg) {
              const [$, P] = e.affix.neg.map((b) => JSON.stringify(b));
              c = `value < 0 ? ${$} + ${c} + ${P} : ${f} + ${c} + ${x}`;
            } else
              c = `${f} + ${c} + ${x}`;
          }
          return a.push(`return function(value) { return ${c}; }`), a.join(`
  `) + `
})()`;
        }
        var O = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : z.g !== void 0 ? z.g : typeof self < "u" ? self : {};
        function B(t) {
          return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var H = {}, pt = {}, wt = { exports: {} };
        (function(t) {
          var e, n;
          e = O, n = function() {
            var r = Object.prototype.hasOwnProperty, i = Object.prototype.toString, o = typeof new RegExp().sticky == "boolean";
            function s(u) {
              return u && i.call(u) === "[object RegExp]";
            }
            function a(u) {
              return u && typeof u == "object" && !s(u) && !Array.isArray(u);
            }
            function c(u) {
              return "(" + u + ")";
            }
            function f(u) {
              return u.length ? "(?:" + u.map(function(T) {
                return "(?:" + T + ")";
              }).join("|") + ")" : "(?!)";
            }
            function x(u) {
              if (typeof u == "string")
                return "(?:" + u.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&") + ")";
              if (s(u)) {
                if (u.ignoreCase)
                  throw new Error("RegExp /i flag not allowed");
                if (u.global)
                  throw new Error("RegExp /g flag is implied");
                if (u.sticky)
                  throw new Error("RegExp /y flag is implied");
                if (u.multiline)
                  throw new Error("RegExp /m flag is implied");
                return u.source;
              }
              throw new Error("Not a pattern: " + u);
            }
            function $(u, T) {
              return u.length > T ? u : Array(T - u.length + 1).join(" ") + u;
            }
            function P(u, T) {
              if (a(T) || (T = { match: T }), T.include)
                throw new Error("Matching rules cannot also include states");
              var D = { defaultType: u, lineBreaks: !!T.error || !!T.fallback, pop: !1, next: null, push: null, error: !1, fallback: !1, value: null, type: null, shouldThrow: !1 };
              for (var R in T)
                r.call(T, R) && (D[R] = T[R]);
              if (typeof D.type == "string" && u !== D.type)
                throw new Error("Type transform cannot be a string (type '" + D.type + "' for token '" + u + "')");
              var G = D.match;
              return D.match = Array.isArray(G) ? G : G ? [G] : [], D.match.sort(function(L, et) {
                return s(L) && s(et) ? 0 : s(et) ? -1 : s(L) ? 1 : et.length - L.length;
              }), D;
            }
            function b(u) {
              return Array.isArray(u) ? function(T) {
                for (var D = [], R = 0; R < T.length; R++) {
                  var G = T[R];
                  if (G.include)
                    for (var L = [].concat(G.include), et = 0; et < L.length; et++)
                      D.push({ include: L[et] });
                  else {
                    if (!G.type)
                      throw new Error("Rule has no type: " + JSON.stringify(G));
                    D.push(P(G.type, G));
                  }
                }
                return D;
              }(u) : function(T) {
                for (var D = Object.getOwnPropertyNames(T), R = [], G = 0; G < D.length; G++) {
                  var L = D[G], et = T[L], ht = [].concat(et);
                  if (L !== "include") {
                    var rt = [];
                    ht.forEach(function(_t) {
                      a(_t) ? (rt.length && R.push(P(L, rt)), R.push(P(L, _t)), rt = []) : rt.push(_t);
                    }), rt.length && R.push(P(L, rt));
                  } else
                    for (var it = 0; it < ht.length; it++)
                      R.push({ include: ht[it] });
                }
                return R;
              }(u);
            }
            var q = P("error", { lineBreaks: !0, shouldThrow: !0 });
            function lt(u, T) {
              for (var D = null, R = /* @__PURE__ */ Object.create(null), G = !0, L = null, et = [], ht = [], rt = 0; rt < u.length; rt++)
                u[rt].fallback && (G = !1);
              for (rt = 0; rt < u.length; rt++) {
                var it = u[rt];
                if (it.include)
                  throw new Error("Inheritance is not allowed in stateless lexers");
                if (it.error || it.fallback) {
                  if (D)
                    throw !it.fallback == !D.fallback ? new Error("Multiple " + (it.fallback ? "fallback" : "error") + " rules not allowed (for token '" + it.defaultType + "')") : new Error("fallback and error are mutually exclusive (for token '" + it.defaultType + "')");
                  D = it;
                }
                var _t = it.match.slice();
                if (G)
                  for (; _t.length && typeof _t[0] == "string" && _t[0].length === 1; )
                    R[_t.shift().charCodeAt(0)] = it;
                if (it.pop || it.push || it.next) {
                  if (!T)
                    throw new Error("State-switching options are not allowed in stateless lexers (for token '" + it.defaultType + "')");
                  if (it.fallback)
                    throw new Error("State-switching options are not allowed on fallback tokens (for token '" + it.defaultType + "')");
                }
                if (_t.length !== 0) {
                  G = !1, et.push(it);
                  for (var Ut = 0; Ut < _t.length; Ut++) {
                    var Kt = _t[Ut];
                    if (s(Kt)) {
                      if (L === null)
                        L = Kt.unicode;
                      else if (L !== Kt.unicode && it.fallback === !1)
                        throw new Error("If one rule is /u then all must be");
                    }
                  }
                  var Ht = f(_t.map(x)), It = new RegExp(Ht);
                  if (It.test(""))
                    throw new Error("RegExp matches empty string: " + It);
                  if (new RegExp("|" + Ht).exec("").length - 1 > 0)
                    throw new Error("RegExp has capture groups: " + It + `
Use (?: … ) instead`);
                  if (!it.lineBreaks && It.test(`
`))
                    throw new Error("Rule should declare lineBreaks: " + It);
                  ht.push(c(Ht));
                }
              }
              var Bt = D && D.fallback, ie = o && !Bt ? "ym" : "gm", fe = o || Bt ? "" : "|";
              return L === !0 && (ie += "u"), { regexp: new RegExp(f(ht) + fe, ie), groups: et, fast: R, error: D || q };
            }
            function ut(u, T, D) {
              var R = u && (u.push || u.next);
              if (R && !D[R])
                throw new Error("Missing state '" + R + "' (in token '" + u.defaultType + "' of state '" + T + "')");
              if (u && u.pop && +u.pop != 1)
                throw new Error("pop must be 1 (in token '" + u.defaultType + "' of state '" + T + "')");
            }
            var Y = function(u, T) {
              this.startState = T, this.states = u, this.buffer = "", this.stack = [], this.reset();
            };
            Y.prototype.reset = function(u, T) {
              return this.buffer = u || "", this.index = 0, this.line = T ? T.line : 1, this.col = T ? T.col : 1, this.queuedToken = T ? T.queuedToken : null, this.queuedText = T ? T.queuedText : "", this.queuedThrow = T ? T.queuedThrow : null, this.setState(T ? T.state : this.startState), this.stack = T && T.stack ? T.stack.slice() : [], this;
            }, Y.prototype.save = function() {
              return { line: this.line, col: this.col, state: this.state, stack: this.stack.slice(), queuedToken: this.queuedToken, queuedText: this.queuedText, queuedThrow: this.queuedThrow };
            }, Y.prototype.setState = function(u) {
              if (u && this.state !== u) {
                this.state = u;
                var T = this.states[u];
                this.groups = T.groups, this.error = T.error, this.re = T.regexp, this.fast = T.fast;
              }
            }, Y.prototype.popState = function() {
              this.setState(this.stack.pop());
            }, Y.prototype.pushState = function(u) {
              this.stack.push(this.state), this.setState(u);
            };
            var jt = o ? function(u, T) {
              return u.exec(T);
            } : function(u, T) {
              var D = u.exec(T);
              return D[0].length === 0 ? null : D;
            };
            function St() {
              return this.value;
            }
            if (Y.prototype._getGroup = function(u) {
              for (var T = this.groups.length, D = 0; D < T; D++)
                if (u[D + 1] !== void 0)
                  return this.groups[D];
              throw new Error("Cannot find token type for matched text");
            }, Y.prototype.next = function() {
              var u = this.index;
              if (this.queuedGroup) {
                var T = this._token(this.queuedGroup, this.queuedText, u);
                return this.queuedGroup = null, this.queuedText = "", T;
              }
              var D = this.buffer;
              if (u !== D.length) {
                if (et = this.fast[D.charCodeAt(u)])
                  return this._token(et, D.charAt(u), u);
                var R = this.re;
                R.lastIndex = u;
                var G = jt(R, D), L = this.error;
                if (G == null)
                  return this._token(L, D.slice(u, D.length), u);
                var et = this._getGroup(G), ht = G[0];
                return L.fallback && G.index !== u ? (this.queuedGroup = et, this.queuedText = ht, this._token(L, D.slice(u, G.index), u)) : this._token(et, ht, u);
              }
            }, Y.prototype._token = function(u, T, D) {
              var R = 0;
              if (u.lineBreaks) {
                var G = /\n/g, L = 1;
                if (T === `
`)
                  R = 1;
                else
                  for (; G.exec(T); )
                    R++, L = G.lastIndex;
              }
              var et = { type: typeof u.type == "function" && u.type(T) || u.defaultType, value: typeof u.value == "function" ? u.value(T) : T, text: T, toString: St, offset: D, lineBreaks: R, line: this.line, col: this.col }, ht = T.length;
              if (this.index += ht, this.line += R, R !== 0 ? this.col = ht - L + 1 : this.col += ht, u.shouldThrow)
                throw new Error(this.formatError(et, "invalid syntax"));
              return u.pop ? this.popState() : u.push ? this.pushState(u.push) : u.next && this.setState(u.next), et;
            }, typeof Symbol < "u" && Symbol.iterator) {
              var kt = function(u) {
                this.lexer = u;
              };
              kt.prototype.next = function() {
                var u = this.lexer.next();
                return { value: u, done: !u };
              }, kt.prototype[Symbol.iterator] = function() {
                return this;
              }, Y.prototype[Symbol.iterator] = function() {
                return new kt(this);
              };
            }
            return Y.prototype.formatError = function(u, T) {
              if (u == null) {
                var D = this.buffer.slice(this.index);
                u = { text: D, offset: this.index, lineBreaks: D.indexOf(`
`) === -1 ? 0 : 1, line: this.line, col: this.col };
              }
              var R = Math.max(u.line - 2, 1), G = u.line + 2, L = String(G).length, et = function(Ut, Kt) {
                for (var Ht = Ut.length, It = 0; ; ) {
                  var Bt = Ut.lastIndexOf(`
`, Ht - 1);
                  if (Bt === -1 || (Ht = Bt, ++It === Kt) || Ht === 0)
                    break;
                }
                var ie = It < Kt ? 0 : Ht + 1;
                return Ut.substring(ie).split(`
`);
              }(this.buffer, this.line - u.line + 2 + 1).slice(0, 5), ht = [];
              ht.push(T + " at line " + u.line + " col " + u.col + ":"), ht.push("");
              for (var rt = 0; rt < et.length; rt++) {
                var it = et[rt], _t = R + rt;
                ht.push($(String(_t), L) + "  " + it), _t === u.line && ht.push($("", L + u.col + 1) + "^");
              }
              return ht.join(`
`);
            }, Y.prototype.clone = function() {
              return new Y(this.states, this.state);
            }, Y.prototype.has = function(u) {
              return !0;
            }, { compile: function(u) {
              var T = lt(b(u));
              return new Y({ start: T }, "start");
            }, states: function(u, T) {
              var D = u.$all ? b(u.$all) : [];
              delete u.$all;
              var R = Object.getOwnPropertyNames(u);
              T || (T = R[0]);
              for (var G = /* @__PURE__ */ Object.create(null), L = 0; L < R.length; L++)
                G[Bt = R[L]] = b(u[Bt]).concat(D);
              for (L = 0; L < R.length; L++)
                for (var et = G[Bt = R[L]], ht = /* @__PURE__ */ Object.create(null), rt = 0; rt < et.length; rt++) {
                  var it = et[rt];
                  if (it.include) {
                    var _t = [rt, 1];
                    if (it.include !== Bt && !ht[it.include]) {
                      ht[it.include] = !0;
                      var Ut = G[it.include];
                      if (!Ut)
                        throw new Error("Cannot include nonexistent state '" + it.include + "' (in state '" + Bt + "')");
                      for (var Kt = 0; Kt < Ut.length; Kt++) {
                        var Ht = Ut[Kt];
                        et.indexOf(Ht) === -1 && _t.push(Ht);
                      }
                    }
                    et.splice.apply(et, _t), rt--;
                  }
                }
              var It = /* @__PURE__ */ Object.create(null);
              for (L = 0; L < R.length; L++) {
                var Bt;
                It[Bt = R[L]] = lt(G[Bt], !0);
              }
              for (L = 0; L < R.length; L++) {
                var ie = R[L], fe = It[ie], Ne = fe.groups;
                for (rt = 0; rt < Ne.length; rt++)
                  ut(Ne[rt], ie, It);
                var je = Object.getOwnPropertyNames(fe.fast);
                for (rt = 0; rt < je.length; rt++)
                  ut(fe.fast[je[rt]], ie, It);
              }
              return new Y(It, T);
            }, error: Object.freeze({ error: !0 }), fallback: Object.freeze({ fallback: !0 }), keywords: function(u) {
              for (var T = typeof Map < "u", D = T ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null), R = Object.getOwnPropertyNames(u), G = 0; G < R.length; G++) {
                var L = R[G], et = u[L];
                (Array.isArray(et) ? et : [et]).forEach(function(ht) {
                  if (typeof ht != "string")
                    throw new Error("keyword must be string (in keyword '" + L + "')");
                  T ? D.set(ht, L) : D[ht] = L;
                });
              }
              return function(ht) {
                return T ? D.get(ht) : D[ht];
              };
            } };
          }, t.exports ? t.exports = n() : e.moo = n();
        })(wt);
        var xt = wt.exports;
        (function(t) {
          var e = O && O.__importDefault || function(r) {
            return r && r.__esModule ? r : { default: r };
          };
          Object.defineProperty(t, "__esModule", { value: !0 }), t.lexer = t.states = void 0;
          const n = e(xt);
          t.states = { body: { doubleapos: { match: "''", value: () => "'" }, quoted: { lineBreaks: !0, match: /'[{}#](?:[^]*?[^'])?'(?!')/u, value: (r) => r.slice(1, -1).replace(/''/g, "'") }, argument: { lineBreaks: !0, match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u, push: "arg", value: (r) => r.substring(1).trim() }, octothorpe: "#", end: { match: "}", pop: 1 }, content: { lineBreaks: !0, match: /[^][^{}#']*/u } }, arg: { select: { lineBreaks: !0, match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u, next: "select", value: (r) => r.split(",")[1].trim() }, "func-args": { lineBreaks: !0, match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u, next: "body", value: (r) => r.split(",")[1].trim() }, "func-simple": { lineBreaks: !0, match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u, value: (r) => r.substring(1).trim() }, end: { match: "}", pop: 1 } }, select: { offset: { lineBreaks: !0, match: /\s*offset\s*:\s*\d+\s*/u, value: (r) => r.split(":")[1].trim() }, case: { lineBreaks: !0, match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u, push: "body", value: (r) => r.substring(0, r.indexOf("{")).trim() }, end: { match: /\s*\}/u, pop: 1 } } }, t.lexer = n.default.states(t.states);
        })(pt), Object.defineProperty(H, "__esModule", { value: !0 });
        var $t = H.parse = H.ParseError = void 0;
        const Tt = pt, ce = (t) => ({ offset: t.offset, line: t.line, col: t.col, text: t.text, lineBreaks: t.lineBreaks }), we = (t) => t === "plural" || t === "select" || t === "selectordinal", De = ["number", "date", "time", "spellout", "ordinal", "duration"], Te = ["zero", "one", "two", "few", "many", "other"];
        class Ot extends Error {
          constructor(e, n) {
            super(Tt.lexer.formatError(e, n));
          }
        }
        H.ParseError = Ot;
        class Ie {
          constructor(e, n) {
            var r, i, o, s;
            this.lexer = Tt.lexer.reset(e), this.cardinalKeys = (r = n == null ? void 0 : n.cardinal) !== null && r !== void 0 ? r : Te, this.ordinalKeys = (i = n == null ? void 0 : n.ordinal) !== null && i !== void 0 ? i : Te, this.strict = (o = n == null ? void 0 : n.strict) !== null && o !== void 0 && o, this.strictPluralKeys = (s = n == null ? void 0 : n.strictPluralKeys) === null || s === void 0 || s;
          }
          parse() {
            return this.parseBody(!1, !0);
          }
          checkSelectKey(e, n, r) {
            if (r[0] === "=") {
              if (n === "select")
                throw new Ot(e, `The case ${r} is not valid with select`);
            } else if (n !== "select") {
              const i = n === "plural" ? this.cardinalKeys : this.ordinalKeys;
              if (this.strictPluralKeys && i.length > 0 && !i.includes(r))
                throw new Ot(e, `The ${n} case ${r} is not valid in this locale`);
            }
          }
          parseSelect(e, n, r, i) {
            let { value: o } = e;
            const s = { type: i, arg: o, cases: [], ctx: r };
            i === "plural" || i === "selectordinal" ? n = !0 : this.strict && (n = !1);
            for (const a of this.lexer)
              switch (a.type) {
                case "offset":
                  if (i === "select")
                    throw new Ot(a, "Unexpected plural offset for select");
                  if (s.cases.length > 0)
                    throw new Ot(a, "Plural offset must be set before cases");
                  s.pluralOffset = Number(a.value), r.text += a.text, r.lineBreaks += a.lineBreaks;
                  break;
                case "case":
                  this.checkSelectKey(a, i, a.value), s.cases.push({ key: a.value, tokens: this.parseBody(n), ctx: ce(a) });
                  break;
                case "end":
                  return s;
                default:
                  throw new Ot(a, `Unexpected lexer token: ${a.type}`);
              }
            throw new Ot(null, "Unexpected message end");
          }
          parseArgToken(e, n) {
            const r = ce(e), i = this.lexer.next();
            if (!i)
              throw new Ot(null, "Unexpected message end");
            if (r.text += i.text, r.lineBreaks += i.lineBreaks, this.strict && (i.type === "func-simple" || i.type === "func-args") && !De.includes(i.value)) {
              const o = `Invalid strict mode function arg type: ${i.value}`;
              throw new Ot(e, o);
            }
            switch (i.type) {
              case "end":
                return { type: "argument", arg: e.value, ctx: r };
              case "func-simple": {
                const o = this.lexer.next();
                if (!o)
                  throw new Ot(null, "Unexpected message end");
                if (o.type !== "end")
                  throw new Ot(o, `Unexpected lexer token: ${o.type}`);
                if (r.text += o.text, we(i.value.toLowerCase()))
                  throw new Ot(i, `Invalid type identifier: ${i.value}`);
                return { type: "function", arg: e.value, key: i.value, ctx: r };
              }
              case "func-args": {
                if (we(i.value.toLowerCase())) {
                  const s = `Invalid type identifier: ${i.value}`;
                  throw new Ot(i, s);
                }
                let o = this.parseBody(!this.strict && n);
                return this.strict && o.length > 0 && (o = function(s, a) {
                  let c = "", f = "";
                  for (const x of a) {
                    const $ = x.ctx.text;
                    switch (f += $, x.type) {
                      case "content":
                        c += x.value;
                        break;
                      case "argument":
                      case "function":
                      case "octothorpe":
                        c += $;
                        break;
                      default:
                        throw new Ot(s, `Unsupported part in strict mode function arg style: ${$}`);
                    }
                  }
                  return [{ type: "content", value: c.trim(), ctx: Object.assign({}, a[0].ctx, { text: f }) }];
                }(e, o)), { type: "function", arg: e.value, key: i.value, param: o, ctx: r };
              }
              case "select":
                if (we(i.value))
                  return this.parseSelect(e, n, r, i.value);
                throw new Ot(i, `Unexpected select type ${i.value}`);
              default:
                throw new Ot(i, `Unexpected lexer token: ${i.type}`);
            }
          }
          parseBody(e, n) {
            const r = [];
            let i = null;
            for (const o of this.lexer)
              if (o.type === "argument")
                i && (i = null), r.push(this.parseArgToken(o, e));
              else if (o.type === "octothorpe" && e)
                i && (i = null), r.push({ type: "octothorpe", ctx: ce(o) });
              else {
                if (o.type === "end" && !n)
                  return r;
                {
                  let s = o.value;
                  if (!e && o.type === "quoted" && s[0] === "#") {
                    if (s.includes("{"))
                      throw new Ot(o, `Unsupported escape pattern: ${s}`);
                    s = o.text;
                  }
                  i ? (i.value += s, i.ctx.text += o.text, i.ctx.lineBreaks += o.lineBreaks) : (i = { type: "content", value: s, ctx: ce(o) }, r.push(i));
                }
              }
            if (n)
              return r;
            throw new Ot(null, "Unexpected message end");
          }
        }
        function he(t) {
          return he[t] || (he[t] = new Intl.NumberFormat(t));
        }
        $t = H.parse = function(t) {
          return new Ie(t, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).parse();
        };
        var Fe = Object.freeze({ __proto__: null, _nf: he, number: function(t, e, n) {
          return he(t).format(e - n);
        }, plural: function(t, e, n, r, i) {
          if ({}.hasOwnProperty.call(r, t))
            return r[t];
          e && (t -= e);
          var o = n(t, i);
          return o in r ? r[o] : r.other;
        }, reqArgs: function(t, e) {
          for (var n = 0; n < t.length; ++n)
            if (!e || e[t[n]] === void 0)
              throw new Error("Message requires argument '".concat(t[n], "'"));
        }, select: function(t, e) {
          return {}.hasOwnProperty.call(e, t) ? e[t] : e.other;
        }, strictNumber: function(t, e, n, r) {
          var i = e - n;
          if (isNaN(i))
            throw new Error("`" + r + "` or its offset is not a number");
          return he(t).format(i);
        } }), be = {};
        function de(t, e) {
          var n = String(t) + JSON.stringify(e);
          return be[n] || (be[n] = new Intl.NumberFormat(t, e)), be[n];
        }
        var ve = Object.freeze({ __proto__: null, date: function(t, e, n) {
          var r = { day: "numeric", month: "short", year: "numeric" };
          switch (n) {
            case "full":
              r.weekday = "long";
            case "long":
              r.month = "long";
              break;
            case "short":
              r.month = "numeric";
          }
          return new Date(t).toLocaleDateString(e, r);
        }, duration: function(t) {
          if (typeof t != "number" && (t = Number(t)), !isFinite(t))
            return String(t);
          var e = "";
          t < 0 ? (e = "-", t = Math.abs(t)) : t = Number(t);
          var n = t % 60, r = [Math.round(n) === n ? n : n.toFixed(3)];
          return t < 60 ? r.unshift(0) : (t = Math.round((t - Number(r[0])) / 60), r.unshift(t % 60), t >= 60 && (t = Math.round((t - Number(r[0])) / 60), r.unshift(t))), e + r.shift() + ":" + r.map(function(i) {
            return Number(i) < 10 ? "0" + String(i) : String(i);
          }).join(":");
        }, numberCurrency: function(t, e, n) {
          return de(e, { style: "currency", currency: n, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(t);
        }, numberFmt: function(t, e, n, r) {
          var i = n && n.split(":") || [], o = i[0], s = i[1];
          return de(e, { integer: { maximumFractionDigits: 0 }, percent: { style: "percent" }, currency: { style: "currency", currency: s && s.trim() || r, minimumFractionDigits: 2, maximumFractionDigits: 2 } }[o] || {}).format(t);
        }, numberInteger: function(t, e) {
          return de(e, { maximumFractionDigits: 0 }).format(t);
        }, numberPercent: function(t, e) {
          return de(e, { style: "percent" }).format(t);
        }, time: function(t, e, n) {
          var r = { second: "numeric", minute: "numeric", hour: "numeric" };
          switch (n) {
            case "full":
            case "long":
              r.timeZoneName = "short";
              break;
            case "short":
              delete r.second;
          }
          return new Date(t).toLocaleTimeString(e, r);
        } }), ke = B({ ES3: { break: !0, continue: !0, delete: !0, else: !0, for: !0, function: !0, if: !0, in: !0, new: !0, return: !0, this: !0, typeof: !0, var: !0, void: !0, while: !0, with: !0, case: !0, catch: !0, default: !0, do: !0, finally: !0, instanceof: !0, switch: !0, throw: !0, try: !0 }, ESnext: { await: !0, debugger: !0, class: !0, enum: !0, extends: !0, super: !0, const: !0, export: !0, import: !0, null: !0, true: !0, false: !0, implements: !0, let: !0, private: !0, public: !0, yield: !0, interface: !0, package: !0, protected: !0, static: !0 } });
        function ne(t, e) {
          e && (t += " " + function(r) {
            let i = 0;
            for (let o = 0; o < r.length; ++o)
              i = (i << 5) - i + r.charCodeAt(o), i |= 0;
            return i;
          }(t).toString(36));
          const n = t.trim().replace(/\W+/g, "_");
          return ke.ES3[n] || ke.ESnext[n] || /^\d/.test(n) ? "_" + n : n;
        }
        function xe(t, e) {
          if (/^[A-Z_$][0-9A-Z_$]*$/i.test(e) && !ke.ES3[e])
            return t ? t + "." + e : e;
          {
            const n = JSON.stringify(e);
            return t ? t + "[" + n + "]" : n;
          }
        }
        var Be = new RegExp("^" + ["ar", "ckb", "fa", "he", "ks($|[^bfh])", "lrc", "mzn", "pa-Arab", "ps", "ug", "ur", "uz-Arab", "yi"].join("|^")), Oe = "@messageformat/runtime/lib/plurals", Le = function() {
          function t(e) {
            this.arguments = [], this.runtime = {}, this.options = e;
          }
          return t.prototype.compile = function(e, n, r) {
            var i, o, s = this, a = this.options, c = a.localeCodeFromKey, f = a.requireAllArguments, x = a.strict, $ = a.strictPluralKeys;
            if (typeof e == "object") {
              var P = {};
              try {
                for (var b = I(Object.keys(e)), q = b.next(); !q.done; q = b.next()) {
                  var lt = q.value, ut = c ? c(lt) : lt, Y = r && ut && r[ut] || n;
                  P[lt] = this.compile(e[lt], Y, r);
                }
              } catch (D) {
                i = { error: D };
              } finally {
                try {
                  q && !q.done && (o = b.return) && o.call(b);
                } finally {
                  if (i)
                    throw i.error;
                }
              }
              return P;
            }
            this.plural = n;
            var jt = { cardinal: n.cardinals, ordinal: n.ordinals, strict: x, strictPluralKeys: $ };
            this.arguments = [];
            var St = $t(e, jt).map(function(D) {
              return s.token(D, null);
            }), kt = this.arguments.length > 0, u = this.concatenate(St, !0);
            if (f && kt) {
              this.setRuntimeFn("reqArgs");
              var T = JSON.stringify(this.arguments);
              return "(d) => { reqArgs(".concat(T, ", d); return ").concat(u, "; }");
            }
            return "(".concat(kt ? "d" : "", ") => ").concat(u);
          }, t.prototype.cases = function(e, n) {
            var r = this, i = !0, o = e.cases.map(function(x) {
              var $ = x.key, P = x.tokens;
              $ === "other" && (i = !1);
              var b = P.map(function(q) {
                return r.token(q, n);
              });
              return "".concat(xe(null, $.replace(/^=/, "")), ": ").concat(r.concatenate(b, !1));
            });
            if (i) {
              var s = e.type, a = this.plural, c = a.cardinals, f = a.ordinals;
              if (s === "select" || s === "plural" && c.includes("other") || s === "selectordinal" && f.includes("other"))
                throw new Error("No 'other' form found in ".concat(JSON.stringify(e)));
            }
            return "{ ".concat(o.join(", "), " }");
          }, t.prototype.concatenate = function(e, n) {
            return this.options.returnType === "values" && (n || e.length > 1) ? "[" + e.join(", ") + "]" : e.join(" + ") || '""';
          }, t.prototype.token = function(e, n) {
            if (e.type === "content")
              return JSON.stringify(e.value);
            var r, i, o, s, a, c, f = this.plural, x = f.id, $ = f.lc;
            switch ("arg" in e ? (this.arguments.push(e.arg), r = [xe("d", e.arg)]) : r = [], e.type) {
              case "argument":
                return this.options.biDiSupport ? (o = String(r[0]), s = $, a = Be.test(s), c = JSON.stringify(a ? "‏" : "‎"), "".concat(c, " + ").concat(o, " + ").concat(c)) : String(r[0]);
              case "select":
                i = "select", n && this.options.strict && (n = null), r.push(this.cases(e, n)), this.setRuntimeFn("select");
                break;
              case "selectordinal":
                i = "plural", r.push(e.pluralOffset || 0, x, this.cases(e, e), 1), this.setLocale(x, !0), this.setRuntimeFn("plural");
                break;
              case "plural":
                i = "plural", r.push(e.pluralOffset || 0, x, this.cases(e, e)), this.setLocale(x, !1), this.setRuntimeFn("plural");
                break;
              case "function":
                var P = this.options.customFormatters[e.key], b = P && "module" in P && typeof P.module == "function";
                if (!P) {
                  if (e.key === "date") {
                    i = this.setDateFormatter(e, r, n);
                    break;
                  }
                  if (e.key === "number") {
                    i = this.setNumberFormatter(e, r, n);
                    break;
                  }
                }
                if (r.push(JSON.stringify(this.plural.locale)), e.param) {
                  n && this.options.strict && (n = null);
                  var q = this.getFormatterArg(e, n);
                  q && r.push(q);
                }
                i = b ? ne("".concat(e.key, "__").concat(this.plural.locale)) : e.key, this.setFormatter(i, e.key);
                break;
              case "octothorpe":
                if (!n)
                  return '"#"';
                r = [JSON.stringify(this.plural.locale), xe("d", n.arg), n.pluralOffset || 0], this.options.strict ? (i = "strictNumber", r.push(JSON.stringify(n.arg)), this.setRuntimeFn("strictNumber")) : (i = "number", this.setRuntimeFn("number"));
            }
            if (!i)
              throw new Error("Parser error for token " + JSON.stringify(e));
            return "".concat(i, "(").concat(r.join(", "), ")");
          }, t.prototype.runtimeIncludes = function(e, n) {
            if (ne(e) !== e)
              throw new SyntaxError("Reserved word used as ".concat(n, " identifier: ").concat(e));
            var r = this.runtime[e];
            if (!r || r.type === n)
              return r;
            throw new TypeError("Cannot override ".concat(r.type, " runtime function as ").concat(n, ": ").concat(e));
          }, t.prototype.setLocale = function(e, n) {
            var r, i, o, s = this.runtimeIncludes(e, "locale"), a = this.plural, c = a.getCardinal, f = a.getPlural, x = a.isDefault;
            if (!n && x && c) {
              if (s)
                return;
              r = function($) {
                return c($);
              }, i = "@messageformat/runtime/lib/cardinals", o = function() {
                return String(c);
              };
            } else {
              if (s && (!x || s.module === Oe))
                return;
              r = function($, P) {
                return f($, P);
              }, i = x ? Oe : f.module || null, o = function() {
                return String(f);
              };
            }
            this.runtime[e] = Object.assign(r, { id: e, module: i, toString: o, type: "locale" });
          }, t.prototype.setRuntimeFn = function(e) {
            this.runtimeIncludes(e, "runtime") || (this.runtime[e] = Object.assign(Fe[e], { id: e, module: "@messageformat/runtime", type: "runtime" }));
          }, t.prototype.getFormatterArg = function(e, n) {
            var r, i, o, s, a = this, c = e.key, f = e.param, x = this.options.customFormatters[c] || _e(c) && ve[c];
            if (!x || !f)
              return null;
            var $ = "arg" in x && x.arg || "string";
            if ($ === "options") {
              var P = "";
              try {
                for (var b = I(f), q = b.next(); !q.done; q = b.next()) {
                  var lt = q.value;
                  if (lt.type !== "content")
                    throw new SyntaxError("Expected literal options for ".concat(c, " formatter"));
                  P += lt.value;
                }
              } catch (L) {
                r = { error: L };
              } finally {
                try {
                  q && !q.done && (i = b.return) && i.call(b);
                } finally {
                  if (r)
                    throw r.error;
                }
              }
              var ut = {};
              try {
                for (var Y = I(P.split(",")), jt = Y.next(); !jt.done; jt = Y.next()) {
                  var St = jt.value, kt = St.indexOf(":");
                  if (kt === -1)
                    ut[St.trim()] = null;
                  else {
                    var u = St.substring(0, kt).trim(), T = St.substring(kt + 1).trim();
                    if (T === "true")
                      ut[u] = !0;
                    else if (T === "false")
                      ut[u] = !1;
                    else if (T === "null")
                      ut[u] = null;
                    else {
                      var D = Number(T);
                      ut[u] = Number.isFinite(D) ? D : T;
                    }
                  }
                }
              } catch (L) {
                o = { error: L };
              } finally {
                try {
                  jt && !jt.done && (s = Y.return) && s.call(Y);
                } finally {
                  if (o)
                    throw o.error;
                }
              }
              return JSON.stringify(ut);
            }
            var R = f.map(function(L) {
              return a.token(L, n);
            });
            if ($ === "raw")
              return "[".concat(R.join(", "), "]");
            var G = R.join(" + ");
            return G ? "(".concat(G, ").trim()") : '""';
          }, t.prototype.setFormatter = function(e, n) {
            if (!this.runtimeIncludes(e, "formatter")) {
              var r = this.options.customFormatters[n || e];
              if (r) {
                var i = typeof r == "function" ? { formatter: r } : r;
                this.runtime[e] = Object.assign(i.formatter.bind({}), j(j({}, i.formatter.prototype), { toString: function() {
                  return String(i.formatter);
                } }), { type: "formatter" }, "module" in r && r.module && r.id ? { id: ne(r.id), module: typeof r.module == "function" ? r.module(this.plural.locale) : r.module } : { id: null, module: null });
              } else {
                if (!_e(e))
                  throw new Error("Formatting function not found: ".concat(e));
                this.runtime[e] = Object.assign(ve[e], { type: "formatter" }, { id: e, module: "@messageformat/runtime/lib/formatters" });
              }
            }
          }, t.prototype.setDateFormatter = function(e, n, r) {
            var i = this, o = e.param, s = this.plural.locale, a = o && o.length === 1 && o[0];
            if (a && a.type === "content" && /^\s*::/.test(a.value)) {
              var c = a.value.trim().substr(2), f = ne("date_".concat(s, "_").concat(c), !0);
              if (!this.runtimeIncludes(f, "formatter")) {
                var x = function(P, b, q) {
                  typeof b == "string" && (b = U(b));
                  const lt = g(b, q), ut = new Intl.DateTimeFormat(P, lt);
                  return (Y) => ut.format(Y);
                }(s, c);
                this.runtime[f] = Object.assign(x, { id: f, module: null, toString: function() {
                  return function(P, b, q) {
                    typeof b == "string" && (b = U(b));
                    const lt = g(b, q);
                    return ["(function() {", `var opt = ${JSON.stringify(lt)};`, `var dtf = new Intl.DateTimeFormat(${JSON.stringify(P)}, opt);`, "return function(value) { return dtf.format(value); }"].join(`
  `) + `
})()`;
                  }(s, c);
                }, type: "formatter" });
              }
              return f;
            }
            if (n.push(JSON.stringify(s)), o && o.length > 0) {
              r && this.options.strict && (r = null);
              var $ = o.map(function(P) {
                return i.token(P, r);
              });
              n.push("(" + ($.join(" + ") || '""') + ").trim()");
            }
            return this.setFormatter("date"), "date";
          }, t.prototype.setNumberFormatter = function(e, n, r) {
            var i = this, o = e.param, s = this.plural.locale;
            if (!o || o.length === 0)
              return n.unshift(JSON.stringify(s)), n.push("0"), this.setRuntimeFn("number"), "number";
            if (n.push(JSON.stringify(s)), o.length === 1 && o[0].type === "content") {
              var a = o[0].value.trim();
              switch (a) {
                case "currency":
                  return n.push(JSON.stringify(this.options.currency)), this.setFormatter("numberCurrency"), "numberCurrency";
                case "integer":
                  return this.setFormatter("numberInteger"), "numberInteger";
                case "percent":
                  return this.setFormatter("numberPercent"), "numberPercent";
              }
              var c = a.match(/^currency:([A-Z]+)$/);
              if (c)
                return n.push(JSON.stringify(c[1])), this.setFormatter("numberCurrency"), "numberCurrency";
              var f = ne("number_".concat(s, "_").concat(a), !0);
              if (!this.runtimeIncludes(f, "formatter")) {
                var x = this.options.currency, $ = l(s, a, x);
                this.runtime[f] = Object.assign($, { id: null, module: null, toString: function() {
                  return v(s, a, x);
                }, type: "formatter" });
              }
              return f;
            }
            r && this.options.strict && (r = null);
            var P = o.map(function(b) {
              return i.token(b, r);
            });
            return n.push("(" + (P.join(" + ") || '""') + ").trim()"), n.push(JSON.stringify(this.options.currency)), this.setFormatter("numberFmt"), "numberFmt";
          }, t;
        }();
        function _e(t) {
          return t in ve;
        }
        const S = (t) => t == 1 ? "one" : "other", Vt = (t) => t == 0 || t == 1 ? "one" : "other", Gt = (t) => t >= 0 && t <= 1 ? "one" : "other", Nt = (t) => {
          const e = !String(t).split(".")[1];
          return t == 1 && e ? "one" : "other";
        }, Q = (t) => "other", Xt = (t) => t == 1 ? "one" : t == 2 ? "two" : "other";
        var ze = Object.freeze({ __proto__: null, af: S, ak: Vt, am: Gt, an: S, ar: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t && e[0].slice(-2);
          return t == 0 ? "zero" : t == 1 ? "one" : t == 2 ? "two" : n >= 3 && n <= 10 ? "few" : n >= 11 && n <= 99 ? "many" : "other";
        }, ars: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t && e[0].slice(-2);
          return t == 0 ? "zero" : t == 1 ? "one" : t == 2 ? "two" : n >= 3 && n <= 10 ? "few" : n >= 11 && n <= 99 ? "many" : "other";
        }, as: Gt, asa: S, ast: Nt, az: S, bal: S, be: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t, r = n && e[0].slice(-1), i = n && e[0].slice(-2);
          return r == 1 && i != 11 ? "one" : r >= 2 && r <= 4 && (i < 12 || i > 14) ? "few" : n && r == 0 || r >= 5 && r <= 9 || i >= 11 && i <= 14 ? "many" : "other";
        }, bem: S, bez: S, bg: S, bho: Vt, bm: Q, bn: Gt, bo: Q, br: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t, r = n && e[0].slice(-1), i = n && e[0].slice(-2), o = n && e[0].slice(-6);
          return r == 1 && i != 11 && i != 71 && i != 91 ? "one" : r == 2 && i != 12 && i != 72 && i != 92 ? "two" : (r == 3 || r == 4 || r == 9) && (i < 10 || i > 19) && (i < 70 || i > 79) && (i < 90 || i > 99) ? "few" : t != 0 && n && o == 0 ? "many" : "other";
        }, brx: S, bs: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = n.slice(-2), a = r.slice(-1), c = r.slice(-2);
          return i && o == 1 && s != 11 || a == 1 && c != 11 ? "one" : i && o >= 2 && o <= 4 && (s < 12 || s > 14) || a >= 2 && a <= 4 && (c < 12 || c > 14) ? "few" : "other";
        }, ca: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-6);
          return t == 1 && r ? "one" : n != 0 && i == 0 && r ? "many" : "other";
        }, ce: S, ceb: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = r.slice(-1);
          return i && (n == 1 || n == 2 || n == 3) || i && o != 4 && o != 6 && o != 9 || !i && s != 4 && s != 6 && s != 9 ? "one" : "other";
        }, cgg: S, chr: S, ckb: S, cs: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1];
          return t == 1 && r ? "one" : n >= 2 && n <= 4 && r ? "few" : r ? "other" : "many";
        }, cy: (t) => t == 0 ? "zero" : t == 1 ? "one" : t == 2 ? "two" : t == 3 ? "few" : t == 6 ? "many" : "other", da: (t) => {
          const e = String(t).split("."), n = e[0], r = Number(e[0]) == t;
          return t != 1 && (r || n != 0 && n != 1) ? "other" : "one";
        }, de: Nt, doi: Gt, dsb: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-2), s = r.slice(-2);
          return i && o == 1 || s == 1 ? "one" : i && o == 2 || s == 2 ? "two" : i && (o == 3 || o == 4) || s == 3 || s == 4 ? "few" : "other";
        }, dv: S, dz: Q, ee: S, el: S, en: Nt, eo: S, es: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-6);
          return t == 1 ? "one" : n != 0 && i == 0 && r ? "many" : "other";
        }, et: Nt, eu: S, fa: Gt, ff: (t) => t >= 0 && t < 2 ? "one" : "other", fi: Nt, fil: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = r.slice(-1);
          return i && (n == 1 || n == 2 || n == 3) || i && o != 4 && o != 6 && o != 9 || !i && s != 4 && s != 6 && s != 9 ? "one" : "other";
        }, fo: S, fr: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-6);
          return t >= 0 && t < 2 ? "one" : n != 0 && i == 0 && r ? "many" : "other";
        }, fur: S, fy: Nt, ga: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t;
          return t == 1 ? "one" : t == 2 ? "two" : n && t >= 3 && t <= 6 ? "few" : n && t >= 7 && t <= 10 ? "many" : "other";
        }, gd: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t;
          return t == 1 || t == 11 ? "one" : t == 2 || t == 12 ? "two" : n && t >= 3 && t <= 10 || n && t >= 13 && t <= 19 ? "few" : "other";
        }, gl: Nt, gsw: S, gu: Gt, guw: Vt, gv: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-1), o = n.slice(-2);
          return r && i == 1 ? "one" : r && i == 2 ? "two" : !r || o != 0 && o != 20 && o != 40 && o != 60 && o != 80 ? r ? "other" : "many" : "few";
        }, ha: S, haw: S, he: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1];
          return n == 1 && r || n == 0 && !r ? "one" : n == 2 && r ? "two" : "other";
        }, hi: Gt, hnj: Q, hr: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = n.slice(-2), a = r.slice(-1), c = r.slice(-2);
          return i && o == 1 && s != 11 || a == 1 && c != 11 ? "one" : i && o >= 2 && o <= 4 && (s < 12 || s > 14) || a >= 2 && a <= 4 && (c < 12 || c > 14) ? "few" : "other";
        }, hsb: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-2), s = r.slice(-2);
          return i && o == 1 || s == 1 ? "one" : i && o == 2 || s == 2 ? "two" : i && (o == 3 || o == 4) || s == 3 || s == 4 ? "few" : "other";
        }, hu: S, hy: (t) => t >= 0 && t < 2 ? "one" : "other", ia: Nt, id: Q, ig: Q, ii: Q, io: Nt, is: (t) => {
          const e = String(t).split("."), n = e[0], r = (e[1] || "").replace(/0+$/, ""), i = Number(e[0]) == t, o = n.slice(-1), s = n.slice(-2);
          return i && o == 1 && s != 11 || r % 10 == 1 && r % 100 != 11 ? "one" : "other";
        }, it: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-6);
          return t == 1 && r ? "one" : n != 0 && i == 0 && r ? "many" : "other";
        }, iu: Xt, ja: Q, jbo: Q, jgo: S, jmc: S, jv: Q, jw: Q, ka: S, kab: (t) => t >= 0 && t < 2 ? "one" : "other", kaj: S, kcg: S, kde: Q, kea: Q, kk: S, kkj: S, kl: S, km: Q, kn: Gt, ko: Q, ks: S, ksb: S, ksh: (t) => t == 0 ? "zero" : t == 1 ? "one" : "other", ku: S, kw: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t, r = n && e[0].slice(-2), i = n && e[0].slice(-3), o = n && e[0].slice(-5), s = n && e[0].slice(-6);
          return t == 0 ? "zero" : t == 1 ? "one" : r == 2 || r == 22 || r == 42 || r == 62 || r == 82 || n && i == 0 && (o >= 1e3 && o <= 2e4 || o == 4e4 || o == 6e4 || o == 8e4) || t != 0 && s == 1e5 ? "two" : r == 3 || r == 23 || r == 43 || r == 63 || r == 83 ? "few" : t == 1 || r != 1 && r != 21 && r != 41 && r != 61 && r != 81 ? "other" : "many";
        }, ky: S, lag: (t) => {
          const e = String(t).split(".")[0];
          return t == 0 ? "zero" : e != 0 && e != 1 || t == 0 ? "other" : "one";
        }, lb: S, lg: S, lij: Nt, lkt: Q, ln: Vt, lo: Q, lt: (t) => {
          const e = String(t).split("."), n = e[1] || "", r = Number(e[0]) == t, i = r && e[0].slice(-1), o = r && e[0].slice(-2);
          return i == 1 && (o < 11 || o > 19) ? "one" : i >= 2 && i <= 9 && (o < 11 || o > 19) ? "few" : n != 0 ? "many" : "other";
        }, lv: (t) => {
          const e = String(t).split("."), n = e[1] || "", r = n.length, i = Number(e[0]) == t, o = i && e[0].slice(-1), s = i && e[0].slice(-2), a = n.slice(-2), c = n.slice(-1);
          return i && o == 0 || s >= 11 && s <= 19 || r == 2 && a >= 11 && a <= 19 ? "zero" : o == 1 && s != 11 || r == 2 && c == 1 && a != 11 || r != 2 && c == 1 ? "one" : "other";
        }, mas: S, mg: Vt, mgo: S, mk: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = n.slice(-2), a = r.slice(-1), c = r.slice(-2);
          return i && o == 1 && s != 11 || a == 1 && c != 11 ? "one" : "other";
        }, ml: S, mn: S, mo: (t) => {
          const e = String(t).split("."), n = !e[1], r = Number(e[0]) == t && e[0].slice(-2);
          return t == 1 && n ? "one" : !n || t == 0 || t != 1 && r >= 1 && r <= 19 ? "few" : "other";
        }, mr: S, ms: Q, mt: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t && e[0].slice(-2);
          return t == 1 ? "one" : t == 2 ? "two" : t == 0 || n >= 3 && n <= 10 ? "few" : n >= 11 && n <= 19 ? "many" : "other";
        }, my: Q, nah: S, naq: Xt, nb: S, nd: S, ne: S, nl: Nt, nn: S, nnh: S, no: S, nqo: Q, nr: S, nso: Vt, ny: S, nyn: S, om: S, or: S, os: S, osa: Q, pa: Vt, pap: S, pcm: Gt, pl: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-1), o = n.slice(-2);
          return t == 1 && r ? "one" : r && i >= 2 && i <= 4 && (o < 12 || o > 14) ? "few" : r && n != 1 && (i == 0 || i == 1) || r && i >= 5 && i <= 9 || r && o >= 12 && o <= 14 ? "many" : "other";
        }, prg: (t) => {
          const e = String(t).split("."), n = e[1] || "", r = n.length, i = Number(e[0]) == t, o = i && e[0].slice(-1), s = i && e[0].slice(-2), a = n.slice(-2), c = n.slice(-1);
          return i && o == 0 || s >= 11 && s <= 19 || r == 2 && a >= 11 && a <= 19 ? "zero" : o == 1 && s != 11 || r == 2 && c == 1 && a != 11 || r != 2 && c == 1 ? "one" : "other";
        }, ps: S, pt: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-6);
          return n == 0 || n == 1 ? "one" : n != 0 && i == 0 && r ? "many" : "other";
        }, pt_PT: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-6);
          return t == 1 && r ? "one" : n != 0 && i == 0 && r ? "many" : "other";
        }, rm: S, ro: (t) => {
          const e = String(t).split("."), n = !e[1], r = Number(e[0]) == t && e[0].slice(-2);
          return t == 1 && n ? "one" : !n || t == 0 || t != 1 && r >= 1 && r <= 19 ? "few" : "other";
        }, rof: S, ru: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-1), o = n.slice(-2);
          return r && i == 1 && o != 11 ? "one" : r && i >= 2 && i <= 4 && (o < 12 || o > 14) ? "few" : r && i == 0 || r && i >= 5 && i <= 9 || r && o >= 11 && o <= 14 ? "many" : "other";
        }, rwk: S, sah: Q, saq: S, sat: Xt, sc: Nt, scn: Nt, sd: S, sdh: S, se: Xt, seh: S, ses: Q, sg: Q, sh: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = n.slice(-2), a = r.slice(-1), c = r.slice(-2);
          return i && o == 1 && s != 11 || a == 1 && c != 11 ? "one" : i && o >= 2 && o <= 4 && (s < 12 || s > 14) || a >= 2 && a <= 4 && (c < 12 || c > 14) ? "few" : "other";
        }, shi: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t;
          return t >= 0 && t <= 1 ? "one" : n && t >= 2 && t <= 10 ? "few" : "other";
        }, si: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "";
          return t == 0 || t == 1 || n == 0 && r == 1 ? "one" : "other";
        }, sk: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1];
          return t == 1 && r ? "one" : n >= 2 && n <= 4 && r ? "few" : r ? "other" : "many";
        }, sl: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-2);
          return r && i == 1 ? "one" : r && i == 2 ? "two" : r && (i == 3 || i == 4) || !r ? "few" : "other";
        }, sma: Xt, smi: Xt, smj: Xt, smn: Xt, sms: Xt, sn: S, so: S, sq: S, sr: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = n.slice(-2), a = r.slice(-1), c = r.slice(-2);
          return i && o == 1 && s != 11 || a == 1 && c != 11 ? "one" : i && o >= 2 && o <= 4 && (s < 12 || s > 14) || a >= 2 && a <= 4 && (c < 12 || c > 14) ? "few" : "other";
        }, ss: S, ssy: S, st: S, su: Q, sv: Nt, sw: Nt, syr: S, ta: S, te: S, teo: S, th: Q, ti: Vt, tig: S, tk: S, tl: (t) => {
          const e = String(t).split("."), n = e[0], r = e[1] || "", i = !e[1], o = n.slice(-1), s = r.slice(-1);
          return i && (n == 1 || n == 2 || n == 3) || i && o != 4 && o != 6 && o != 9 || !i && s != 4 && s != 6 && s != 9 ? "one" : "other";
        }, tn: S, to: Q, tpi: Q, tr: S, ts: S, tzm: (t) => {
          const e = String(t).split("."), n = Number(e[0]) == t;
          return t == 0 || t == 1 || n && t >= 11 && t <= 99 ? "one" : "other";
        }, ug: S, uk: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-1), o = n.slice(-2);
          return r && i == 1 && o != 11 ? "one" : r && i >= 2 && i <= 4 && (o < 12 || o > 14) ? "few" : r && i == 0 || r && i >= 5 && i <= 9 || r && o >= 11 && o <= 14 ? "many" : "other";
        }, und: Q, ur: Nt, uz: S, ve: S, vec: (t) => {
          const e = String(t).split("."), n = e[0], r = !e[1], i = n.slice(-6);
          return t == 1 && r ? "one" : n != 0 && i == 0 && r ? "many" : "other";
        }, vi: Q, vo: S, vun: S, wa: Vt, wae: S, wo: Q, xh: S, xog: S, yi: Nt, yo: Q, yue: Q, zh: Q, zu: Gt });
        const Yt = "zero", A = "one", gt = "two", J = "few", Z = "many", p = "other", d = { cardinal: [A, p], ordinal: [p] }, se = { cardinal: [A, p], ordinal: [A, p] }, at = { cardinal: [p], ordinal: [p] }, Jt = { cardinal: [A, gt, p], ordinal: [p] };
        var Ae = Object.freeze({ __proto__: null, af: d, ak: d, am: d, an: d, ar: { cardinal: [Yt, A, gt, J, Z, p], ordinal: [p] }, ars: { cardinal: [Yt, A, gt, J, Z, p], ordinal: [p] }, as: { cardinal: [A, p], ordinal: [A, gt, J, Z, p] }, asa: d, ast: d, az: { cardinal: [A, p], ordinal: [A, J, Z, p] }, bal: se, be: { cardinal: [A, J, Z, p], ordinal: [J, p] }, bem: d, bez: d, bg: d, bho: d, bm: at, bn: { cardinal: [A, p], ordinal: [A, gt, J, Z, p] }, bo: at, br: { cardinal: [A, gt, J, Z, p], ordinal: [p] }, brx: d, bs: { cardinal: [A, J, p], ordinal: [p] }, ca: { cardinal: [A, Z, p], ordinal: [A, gt, J, p] }, ce: d, ceb: d, cgg: d, chr: d, ckb: d, cs: { cardinal: [A, J, Z, p], ordinal: [p] }, cy: { cardinal: [Yt, A, gt, J, Z, p], ordinal: [Yt, A, gt, J, Z, p] }, da: d, de: d, doi: d, dsb: { cardinal: [A, gt, J, p], ordinal: [p] }, dv: d, dz: at, ee: d, el: d, en: { cardinal: [A, p], ordinal: [A, gt, J, p] }, eo: d, es: { cardinal: [A, Z, p], ordinal: [p] }, et: d, eu: d, fa: d, ff: d, fi: d, fil: se, fo: d, fr: { cardinal: [A, Z, p], ordinal: [A, p] }, fur: d, fy: d, ga: { cardinal: [A, gt, J, Z, p], ordinal: [A, p] }, gd: { cardinal: [A, gt, J, p], ordinal: [A, gt, J, p] }, gl: d, gsw: d, gu: { cardinal: [A, p], ordinal: [A, gt, J, Z, p] }, guw: d, gv: { cardinal: [A, gt, J, Z, p], ordinal: [p] }, ha: d, haw: d, he: Jt, hi: { cardinal: [A, p], ordinal: [A, gt, J, Z, p] }, hnj: at, hr: { cardinal: [A, J, p], ordinal: [p] }, hsb: { cardinal: [A, gt, J, p], ordinal: [p] }, hu: se, hy: se, ia: d, id: at, ig: at, ii: at, io: d, is: d, it: { cardinal: [A, Z, p], ordinal: [Z, p] }, iu: Jt, ja: at, jbo: at, jgo: d, jmc: d, jv: at, jw: at, ka: { cardinal: [A, p], ordinal: [A, Z, p] }, kab: d, kaj: d, kcg: d, kde: at, kea: at, kk: { cardinal: [A, p], ordinal: [Z, p] }, kkj: d, kl: d, km: at, kn: d, ko: at, ks: d, ksb: d, ksh: { cardinal: [Yt, A, p], ordinal: [p] }, ku: d, kw: { cardinal: [Yt, A, gt, J, Z, p], ordinal: [A, Z, p] }, ky: d, lag: { cardinal: [Yt, A, p], ordinal: [p] }, lb: d, lg: d, lij: { cardinal: [A, p], ordinal: [Z, p] }, lkt: at, ln: d, lo: { cardinal: [p], ordinal: [A, p] }, lt: { cardinal: [A, J, Z, p], ordinal: [p] }, lv: { cardinal: [Yt, A, p], ordinal: [p] }, mas: d, mg: d, mgo: d, mk: { cardinal: [A, p], ordinal: [A, gt, Z, p] }, ml: d, mn: d, mo: { cardinal: [A, J, p], ordinal: [A, p] }, mr: { cardinal: [A, p], ordinal: [A, gt, J, p] }, ms: { cardinal: [p], ordinal: [A, p] }, mt: { cardinal: [A, gt, J, Z, p], ordinal: [p] }, my: at, nah: d, naq: Jt, nb: d, nd: d, ne: se, nl: d, nn: d, nnh: d, no: d, nqo: at, nr: d, nso: d, ny: d, nyn: d, om: d, or: { cardinal: [A, p], ordinal: [A, gt, J, Z, p] }, os: d, osa: at, pa: d, pap: d, pcm: d, pl: { cardinal: [A, J, Z, p], ordinal: [p] }, prg: { cardinal: [Yt, A, p], ordinal: [p] }, ps: d, pt: { cardinal: [A, Z, p], ordinal: [p] }, pt_PT: { cardinal: [A, Z, p], ordinal: [p] }, rm: d, ro: { cardinal: [A, J, p], ordinal: [A, p] }, rof: d, ru: { cardinal: [A, J, Z, p], ordinal: [p] }, rwk: d, sah: at, saq: d, sat: Jt, sc: { cardinal: [A, p], ordinal: [Z, p] }, scn: { cardinal: [A, p], ordinal: [Z, p] }, sd: d, sdh: d, se: Jt, seh: d, ses: at, sg: at, sh: { cardinal: [A, J, p], ordinal: [p] }, shi: { cardinal: [A, J, p], ordinal: [p] }, si: d, sk: { cardinal: [A, J, Z, p], ordinal: [p] }, sl: { cardinal: [A, gt, J, p], ordinal: [p] }, sma: Jt, smi: Jt, smj: Jt, smn: Jt, sms: Jt, sn: d, so: d, sq: { cardinal: [A, p], ordinal: [A, Z, p] }, sr: { cardinal: [A, J, p], ordinal: [p] }, ss: d, ssy: d, st: d, su: at, sv: se, sw: d, syr: d, ta: d, te: d, teo: d, th: at, ti: d, tig: d, tk: { cardinal: [A, p], ordinal: [J, p] }, tl: se, tn: d, to: at, tpi: at, tr: d, ts: d, tzm: d, ug: d, uk: { cardinal: [A, J, Z, p], ordinal: [J, p] }, und: at, ur: d, uz: d, ve: d, vec: { cardinal: [A, Z, p], ordinal: [Z, p] }, vi: { cardinal: [p], ordinal: [A, p] }, vo: d, vun: d, wa: d, wae: d, wo: at, xh: d, xog: d, yi: d, yo: at, yue: at, zh: at, zu: d });
        const N = (t, e) => e ? "other" : t == 1 ? "one" : "other", Qt = (t, e) => e ? "other" : t == 0 || t == 1 ? "one" : "other", le = (t, e) => e ? "other" : t >= 0 && t <= 1 ? "one" : "other", Ct = (t, e) => {
          const n = !String(t).split(".")[1];
          return e ? "other" : t == 1 && n ? "one" : "other";
        }, ct = (t, e) => "other", te = (t, e) => e ? "other" : t == 1 ? "one" : t == 2 ? "two" : "other";
        var me = Object.freeze({ __proto__: null, af: N, ak: Qt, am: le, an: N, ar: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t && n[0].slice(-2);
          return e ? "other" : t == 0 ? "zero" : t == 1 ? "one" : t == 2 ? "two" : r >= 3 && r <= 10 ? "few" : r >= 11 && r <= 99 ? "many" : "other";
        }, ars: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t && n[0].slice(-2);
          return e ? "other" : t == 0 ? "zero" : t == 1 ? "one" : t == 2 ? "two" : r >= 3 && r <= 10 ? "few" : r >= 11 && r <= 99 ? "many" : "other";
        }, as: (t, e) => e ? t == 1 || t == 5 || t == 7 || t == 8 || t == 9 || t == 10 ? "one" : t == 2 || t == 3 ? "two" : t == 4 ? "few" : t == 6 ? "many" : "other" : t >= 0 && t <= 1 ? "one" : "other", asa: N, ast: Ct, az: (t, e) => {
          const n = String(t).split(".")[0], r = n.slice(-1), i = n.slice(-2), o = n.slice(-3);
          return e ? r == 1 || r == 2 || r == 5 || r == 7 || r == 8 || i == 20 || i == 50 || i == 70 || i == 80 ? "one" : r == 3 || r == 4 || o == 100 || o == 200 || o == 300 || o == 400 || o == 500 || o == 600 || o == 700 || o == 800 || o == 900 ? "few" : n == 0 || r == 6 || i == 40 || i == 60 || i == 90 ? "many" : "other" : t == 1 ? "one" : "other";
        }, bal: (t, e) => t == 1 ? "one" : "other", be: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t, i = r && n[0].slice(-1), o = r && n[0].slice(-2);
          return e ? i != 2 && i != 3 || o == 12 || o == 13 ? "other" : "few" : i == 1 && o != 11 ? "one" : i >= 2 && i <= 4 && (o < 12 || o > 14) ? "few" : r && i == 0 || i >= 5 && i <= 9 || o >= 11 && o <= 14 ? "many" : "other";
        }, bem: N, bez: N, bg: N, bho: Qt, bm: ct, bn: (t, e) => e ? t == 1 || t == 5 || t == 7 || t == 8 || t == 9 || t == 10 ? "one" : t == 2 || t == 3 ? "two" : t == 4 ? "few" : t == 6 ? "many" : "other" : t >= 0 && t <= 1 ? "one" : "other", bo: ct, br: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t, i = r && n[0].slice(-1), o = r && n[0].slice(-2), s = r && n[0].slice(-6);
          return e ? "other" : i == 1 && o != 11 && o != 71 && o != 91 ? "one" : i == 2 && o != 12 && o != 72 && o != 92 ? "two" : (i == 3 || i == 4 || i == 9) && (o < 10 || o > 19) && (o < 70 || o > 79) && (o < 90 || o > 99) ? "few" : t != 0 && r && s == 0 ? "many" : "other";
        }, brx: N, bs: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = r.slice(-2), c = i.slice(-1), f = i.slice(-2);
          return e ? "other" : o && s == 1 && a != 11 || c == 1 && f != 11 ? "one" : o && s >= 2 && s <= 4 && (a < 12 || a > 14) || c >= 2 && c <= 4 && (f < 12 || f > 14) ? "few" : "other";
        }, ca: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-6);
          return e ? t == 1 || t == 3 ? "one" : t == 2 ? "two" : t == 4 ? "few" : "other" : t == 1 && i ? "one" : r != 0 && o == 0 && i ? "many" : "other";
        }, ce: N, ceb: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = i.slice(-1);
          return e ? "other" : o && (r == 1 || r == 2 || r == 3) || o && s != 4 && s != 6 && s != 9 || !o && a != 4 && a != 6 && a != 9 ? "one" : "other";
        }, cgg: N, chr: N, ckb: N, cs: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1];
          return e ? "other" : t == 1 && i ? "one" : r >= 2 && r <= 4 && i ? "few" : i ? "other" : "many";
        }, cy: (t, e) => e ? t == 0 || t == 7 || t == 8 || t == 9 ? "zero" : t == 1 ? "one" : t == 2 ? "two" : t == 3 || t == 4 ? "few" : t == 5 || t == 6 ? "many" : "other" : t == 0 ? "zero" : t == 1 ? "one" : t == 2 ? "two" : t == 3 ? "few" : t == 6 ? "many" : "other", da: (t, e) => {
          const n = String(t).split("."), r = n[0], i = Number(n[0]) == t;
          return e || t != 1 && (i || r != 0 && r != 1) ? "other" : "one";
        }, de: Ct, doi: le, dsb: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-2), a = i.slice(-2);
          return e ? "other" : o && s == 1 || a == 1 ? "one" : o && s == 2 || a == 2 ? "two" : o && (s == 3 || s == 4) || a == 3 || a == 4 ? "few" : "other";
        }, dv: N, dz: ct, ee: N, el: N, en: (t, e) => {
          const n = String(t).split("."), r = !n[1], i = Number(n[0]) == t, o = i && n[0].slice(-1), s = i && n[0].slice(-2);
          return e ? o == 1 && s != 11 ? "one" : o == 2 && s != 12 ? "two" : o == 3 && s != 13 ? "few" : "other" : t == 1 && r ? "one" : "other";
        }, eo: N, es: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-6);
          return e ? "other" : t == 1 ? "one" : r != 0 && o == 0 && i ? "many" : "other";
        }, et: Ct, eu: N, fa: le, ff: (t, e) => e ? "other" : t >= 0 && t < 2 ? "one" : "other", fi: Ct, fil: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = i.slice(-1);
          return e ? t == 1 ? "one" : "other" : o && (r == 1 || r == 2 || r == 3) || o && s != 4 && s != 6 && s != 9 || !o && a != 4 && a != 6 && a != 9 ? "one" : "other";
        }, fo: N, fr: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-6);
          return e ? t == 1 ? "one" : "other" : t >= 0 && t < 2 ? "one" : r != 0 && o == 0 && i ? "many" : "other";
        }, fur: N, fy: Ct, ga: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t;
          return e ? t == 1 ? "one" : "other" : t == 1 ? "one" : t == 2 ? "two" : r && t >= 3 && t <= 6 ? "few" : r && t >= 7 && t <= 10 ? "many" : "other";
        }, gd: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t;
          return e ? t == 1 || t == 11 ? "one" : t == 2 || t == 12 ? "two" : t == 3 || t == 13 ? "few" : "other" : t == 1 || t == 11 ? "one" : t == 2 || t == 12 ? "two" : r && t >= 3 && t <= 10 || r && t >= 13 && t <= 19 ? "few" : "other";
        }, gl: Ct, gsw: N, gu: (t, e) => e ? t == 1 ? "one" : t == 2 || t == 3 ? "two" : t == 4 ? "few" : t == 6 ? "many" : "other" : t >= 0 && t <= 1 ? "one" : "other", guw: Qt, gv: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-1), s = r.slice(-2);
          return e ? "other" : i && o == 1 ? "one" : i && o == 2 ? "two" : !i || s != 0 && s != 20 && s != 40 && s != 60 && s != 80 ? i ? "other" : "many" : "few";
        }, ha: N, haw: N, he: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1];
          return e ? "other" : r == 1 && i || r == 0 && !i ? "one" : r == 2 && i ? "two" : "other";
        }, hi: (t, e) => e ? t == 1 ? "one" : t == 2 || t == 3 ? "two" : t == 4 ? "few" : t == 6 ? "many" : "other" : t >= 0 && t <= 1 ? "one" : "other", hnj: ct, hr: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = r.slice(-2), c = i.slice(-1), f = i.slice(-2);
          return e ? "other" : o && s == 1 && a != 11 || c == 1 && f != 11 ? "one" : o && s >= 2 && s <= 4 && (a < 12 || a > 14) || c >= 2 && c <= 4 && (f < 12 || f > 14) ? "few" : "other";
        }, hsb: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-2), a = i.slice(-2);
          return e ? "other" : o && s == 1 || a == 1 ? "one" : o && s == 2 || a == 2 ? "two" : o && (s == 3 || s == 4) || a == 3 || a == 4 ? "few" : "other";
        }, hu: (t, e) => e ? t == 1 || t == 5 ? "one" : "other" : t == 1 ? "one" : "other", hy: (t, e) => e ? t == 1 ? "one" : "other" : t >= 0 && t < 2 ? "one" : "other", ia: Ct, id: ct, ig: ct, ii: ct, io: Ct, is: (t, e) => {
          const n = String(t).split("."), r = n[0], i = (n[1] || "").replace(/0+$/, ""), o = Number(n[0]) == t, s = r.slice(-1), a = r.slice(-2);
          return e ? "other" : o && s == 1 && a != 11 || i % 10 == 1 && i % 100 != 11 ? "one" : "other";
        }, it: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-6);
          return e ? t == 11 || t == 8 || t == 80 || t == 800 ? "many" : "other" : t == 1 && i ? "one" : r != 0 && o == 0 && i ? "many" : "other";
        }, iu: te, ja: ct, jbo: ct, jgo: N, jmc: N, jv: ct, jw: ct, ka: (t, e) => {
          const n = String(t).split(".")[0], r = n.slice(-2);
          return e ? n == 1 ? "one" : n == 0 || r >= 2 && r <= 20 || r == 40 || r == 60 || r == 80 ? "many" : "other" : t == 1 ? "one" : "other";
        }, kab: (t, e) => e ? "other" : t >= 0 && t < 2 ? "one" : "other", kaj: N, kcg: N, kde: ct, kea: ct, kk: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t, i = r && n[0].slice(-1);
          return e ? i == 6 || i == 9 || r && i == 0 && t != 0 ? "many" : "other" : t == 1 ? "one" : "other";
        }, kkj: N, kl: N, km: ct, kn: le, ko: ct, ks: N, ksb: N, ksh: (t, e) => e ? "other" : t == 0 ? "zero" : t == 1 ? "one" : "other", ku: N, kw: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t, i = r && n[0].slice(-2), o = r && n[0].slice(-3), s = r && n[0].slice(-5), a = r && n[0].slice(-6);
          return e ? r && t >= 1 && t <= 4 || i >= 1 && i <= 4 || i >= 21 && i <= 24 || i >= 41 && i <= 44 || i >= 61 && i <= 64 || i >= 81 && i <= 84 ? "one" : t == 5 || i == 5 ? "many" : "other" : t == 0 ? "zero" : t == 1 ? "one" : i == 2 || i == 22 || i == 42 || i == 62 || i == 82 || r && o == 0 && (s >= 1e3 && s <= 2e4 || s == 4e4 || s == 6e4 || s == 8e4) || t != 0 && a == 1e5 ? "two" : i == 3 || i == 23 || i == 43 || i == 63 || i == 83 ? "few" : t == 1 || i != 1 && i != 21 && i != 41 && i != 61 && i != 81 ? "other" : "many";
        }, ky: N, lag: (t, e) => {
          const n = String(t).split(".")[0];
          return e ? "other" : t == 0 ? "zero" : n != 0 && n != 1 || t == 0 ? "other" : "one";
        }, lb: N, lg: N, lij: (t, e) => {
          const n = String(t).split("."), r = !n[1], i = Number(n[0]) == t;
          return e ? t == 11 || t == 8 || i && t >= 80 && t <= 89 || i && t >= 800 && t <= 899 ? "many" : "other" : t == 1 && r ? "one" : "other";
        }, lkt: ct, ln: Qt, lo: (t, e) => e && t == 1 ? "one" : "other", lt: (t, e) => {
          const n = String(t).split("."), r = n[1] || "", i = Number(n[0]) == t, o = i && n[0].slice(-1), s = i && n[0].slice(-2);
          return e ? "other" : o == 1 && (s < 11 || s > 19) ? "one" : o >= 2 && o <= 9 && (s < 11 || s > 19) ? "few" : r != 0 ? "many" : "other";
        }, lv: (t, e) => {
          const n = String(t).split("."), r = n[1] || "", i = r.length, o = Number(n[0]) == t, s = o && n[0].slice(-1), a = o && n[0].slice(-2), c = r.slice(-2), f = r.slice(-1);
          return e ? "other" : o && s == 0 || a >= 11 && a <= 19 || i == 2 && c >= 11 && c <= 19 ? "zero" : s == 1 && a != 11 || i == 2 && f == 1 && c != 11 || i != 2 && f == 1 ? "one" : "other";
        }, mas: N, mg: Qt, mgo: N, mk: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = r.slice(-2), c = i.slice(-1), f = i.slice(-2);
          return e ? s == 1 && a != 11 ? "one" : s == 2 && a != 12 ? "two" : s != 7 && s != 8 || a == 17 || a == 18 ? "other" : "many" : o && s == 1 && a != 11 || c == 1 && f != 11 ? "one" : "other";
        }, ml: N, mn: N, mo: (t, e) => {
          const n = String(t).split("."), r = !n[1], i = Number(n[0]) == t && n[0].slice(-2);
          return e ? t == 1 ? "one" : "other" : t == 1 && r ? "one" : !r || t == 0 || t != 1 && i >= 1 && i <= 19 ? "few" : "other";
        }, mr: (t, e) => e ? t == 1 ? "one" : t == 2 || t == 3 ? "two" : t == 4 ? "few" : "other" : t == 1 ? "one" : "other", ms: (t, e) => e && t == 1 ? "one" : "other", mt: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t && n[0].slice(-2);
          return e ? "other" : t == 1 ? "one" : t == 2 ? "two" : t == 0 || r >= 3 && r <= 10 ? "few" : r >= 11 && r <= 19 ? "many" : "other";
        }, my: ct, nah: N, naq: te, nb: N, nd: N, ne: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t;
          return e ? r && t >= 1 && t <= 4 ? "one" : "other" : t == 1 ? "one" : "other";
        }, nl: Ct, nn: N, nnh: N, no: N, nqo: ct, nr: N, nso: Qt, ny: N, nyn: N, om: N, or: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t;
          return e ? t == 1 || t == 5 || r && t >= 7 && t <= 9 ? "one" : t == 2 || t == 3 ? "two" : t == 4 ? "few" : t == 6 ? "many" : "other" : t == 1 ? "one" : "other";
        }, os: N, osa: ct, pa: Qt, pap: N, pcm: le, pl: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-1), s = r.slice(-2);
          return e ? "other" : t == 1 && i ? "one" : i && o >= 2 && o <= 4 && (s < 12 || s > 14) ? "few" : i && r != 1 && (o == 0 || o == 1) || i && o >= 5 && o <= 9 || i && s >= 12 && s <= 14 ? "many" : "other";
        }, prg: (t, e) => {
          const n = String(t).split("."), r = n[1] || "", i = r.length, o = Number(n[0]) == t, s = o && n[0].slice(-1), a = o && n[0].slice(-2), c = r.slice(-2), f = r.slice(-1);
          return e ? "other" : o && s == 0 || a >= 11 && a <= 19 || i == 2 && c >= 11 && c <= 19 ? "zero" : s == 1 && a != 11 || i == 2 && f == 1 && c != 11 || i != 2 && f == 1 ? "one" : "other";
        }, ps: N, pt: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-6);
          return e ? "other" : r == 0 || r == 1 ? "one" : r != 0 && o == 0 && i ? "many" : "other";
        }, pt_PT: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-6);
          return e ? "other" : t == 1 && i ? "one" : r != 0 && o == 0 && i ? "many" : "other";
        }, rm: N, ro: (t, e) => {
          const n = String(t).split("."), r = !n[1], i = Number(n[0]) == t && n[0].slice(-2);
          return e ? t == 1 ? "one" : "other" : t == 1 && r ? "one" : !r || t == 0 || t != 1 && i >= 1 && i <= 19 ? "few" : "other";
        }, rof: N, ru: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-1), s = r.slice(-2);
          return e ? "other" : i && o == 1 && s != 11 ? "one" : i && o >= 2 && o <= 4 && (s < 12 || s > 14) ? "few" : i && o == 0 || i && o >= 5 && o <= 9 || i && s >= 11 && s <= 14 ? "many" : "other";
        }, rwk: N, sah: ct, saq: N, sat: te, sc: (t, e) => {
          const n = !String(t).split(".")[1];
          return e ? t == 11 || t == 8 || t == 80 || t == 800 ? "many" : "other" : t == 1 && n ? "one" : "other";
        }, scn: (t, e) => {
          const n = !String(t).split(".")[1];
          return e ? t == 11 || t == 8 || t == 80 || t == 800 ? "many" : "other" : t == 1 && n ? "one" : "other";
        }, sd: N, sdh: N, se: te, seh: N, ses: ct, sg: ct, sh: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = r.slice(-2), c = i.slice(-1), f = i.slice(-2);
          return e ? "other" : o && s == 1 && a != 11 || c == 1 && f != 11 ? "one" : o && s >= 2 && s <= 4 && (a < 12 || a > 14) || c >= 2 && c <= 4 && (f < 12 || f > 14) ? "few" : "other";
        }, shi: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t;
          return e ? "other" : t >= 0 && t <= 1 ? "one" : r && t >= 2 && t <= 10 ? "few" : "other";
        }, si: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "";
          return e ? "other" : t == 0 || t == 1 || r == 0 && i == 1 ? "one" : "other";
        }, sk: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1];
          return e ? "other" : t == 1 && i ? "one" : r >= 2 && r <= 4 && i ? "few" : i ? "other" : "many";
        }, sl: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-2);
          return e ? "other" : i && o == 1 ? "one" : i && o == 2 ? "two" : i && (o == 3 || o == 4) || !i ? "few" : "other";
        }, sma: te, smi: te, smj: te, smn: te, sms: te, sn: N, so: N, sq: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t, i = r && n[0].slice(-1), o = r && n[0].slice(-2);
          return e ? t == 1 ? "one" : i == 4 && o != 14 ? "many" : "other" : t == 1 ? "one" : "other";
        }, sr: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = r.slice(-2), c = i.slice(-1), f = i.slice(-2);
          return e ? "other" : o && s == 1 && a != 11 || c == 1 && f != 11 ? "one" : o && s >= 2 && s <= 4 && (a < 12 || a > 14) || c >= 2 && c <= 4 && (f < 12 || f > 14) ? "few" : "other";
        }, ss: N, ssy: N, st: N, su: ct, sv: (t, e) => {
          const n = String(t).split("."), r = !n[1], i = Number(n[0]) == t, o = i && n[0].slice(-1), s = i && n[0].slice(-2);
          return e ? o != 1 && o != 2 || s == 11 || s == 12 ? "other" : "one" : t == 1 && r ? "one" : "other";
        }, sw: Ct, syr: N, ta: N, te: N, teo: N, th: ct, ti: Qt, tig: N, tk: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t && n[0].slice(-1);
          return e ? r == 6 || r == 9 || t == 10 ? "few" : "other" : t == 1 ? "one" : "other";
        }, tl: (t, e) => {
          const n = String(t).split("."), r = n[0], i = n[1] || "", o = !n[1], s = r.slice(-1), a = i.slice(-1);
          return e ? t == 1 ? "one" : "other" : o && (r == 1 || r == 2 || r == 3) || o && s != 4 && s != 6 && s != 9 || !o && a != 4 && a != 6 && a != 9 ? "one" : "other";
        }, tn: N, to: ct, tpi: ct, tr: N, ts: N, tzm: (t, e) => {
          const n = String(t).split("."), r = Number(n[0]) == t;
          return e ? "other" : t == 0 || t == 1 || r && t >= 11 && t <= 99 ? "one" : "other";
        }, ug: N, uk: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = Number(n[0]) == t, s = o && n[0].slice(-1), a = o && n[0].slice(-2), c = r.slice(-1), f = r.slice(-2);
          return e ? s == 3 && a != 13 ? "few" : "other" : i && c == 1 && f != 11 ? "one" : i && c >= 2 && c <= 4 && (f < 12 || f > 14) ? "few" : i && c == 0 || i && c >= 5 && c <= 9 || i && f >= 11 && f <= 14 ? "many" : "other";
        }, und: ct, ur: Ct, uz: N, ve: N, vec: (t, e) => {
          const n = String(t).split("."), r = n[0], i = !n[1], o = r.slice(-6);
          return e ? t == 11 || t == 8 || t == 80 || t == 800 ? "many" : "other" : t == 1 && i ? "one" : r != 0 && o == 0 && i ? "many" : "other";
        }, vi: (t, e) => e && t == 1 ? "one" : "other", vo: N, vun: N, wa: Qt, wae: N, wo: ct, xh: N, xog: N, yi: Ct, yo: ct, yue: ct, zh: ct, zu: le });
        function Se(t) {
          if (typeof t != "string" || t.length < 2)
            throw new RangeError("Invalid language tag: ".concat(t));
          if (t.startsWith("pt-PT"))
            return "pt-PT";
          var e = t.match(/.+?(?=[-_])/);
          return e ? e[0] : t;
        }
        function ge(t) {
          if (typeof t == "function") {
            var e = Se(t.name);
            return { isDefault: !1, id: ne(e), lc: e, locale: t.name, getPlural: t, cardinals: t.cardinals || [], ordinals: t.ordinals || [] };
          }
          var n = Se(t), r = ne(n);
          return function(i) {
            return i in me;
          }(r) ? { isDefault: !0, id: r, lc: n, locale: t, getCardinal: ze[r], getPlural: me[r], cardinals: Ae[r].cardinal, ordinals: Ae[r].ordinal } : null;
        }
        function Ce(t) {
          return ne(Se(t)) in me;
        }
        return function() {
          function t(e, n) {
            if (this.plurals = [], this.options = Object.assign({ biDiSupport: !1, currency: "USD", customFormatters: {}, localeCodeFromKey: null, requireAllArguments: !1, returnType: "string", strict: n && n.strictNumberSign || !1, strictPluralKeys: !0 }, n), e === "*" ? this.plurals = (i = t.defaultLocale, (o = Object.keys(me).filter(function(s) {
              return s !== i;
            })).unshift(i), o.map(ge)) : Array.isArray(e) ? this.plurals = e.map(ge).filter(Boolean) : e && (r = ge(e)) && (this.plurals = [r]), this.plurals.length === 0) {
              var r = ge(t.defaultLocale);
              this.plurals = [r];
            }
            var i, o;
          }
          return t.escape = function(e, n) {
            var r = n ? /[#{}]/g : /[{}]/g;
            return String(e).replace(r, "'$&'");
          }, t.supportedLocalesOf = function(e) {
            return (Array.isArray(e) ? e : [e]).filter(Ce);
          }, t.prototype.resolvedOptions = function() {
            return j(j({}, this.options), { locale: this.plurals[0].locale, plurals: this.plurals });
          }, t.prototype.compile = function(e) {
            var n, r, i = new Le(this.options), o = "return " + i.compile(e, this.plurals[0]), s = [], a = [];
            try {
              for (var c = I(Object.entries(i.runtime)), f = c.next(); !f.done; f = c.next()) {
                var x = M(f.value, 2), $ = x[0], P = x[1];
                s.push($), a.push(P);
              }
            } catch (b) {
              n = { error: b };
            } finally {
              try {
                f && !f.done && (r = c.return) && r.call(c);
              } finally {
                if (n)
                  throw n.error;
              }
            }
            return new (Function.bind.apply(Function, ft(ft([void 0], M(s), !1), [o], !1)))().apply(void 0, ft([], M(a), !1));
          }, t.defaultLocale = "en", t;
        }();
      }();
    }, 260: (ot) => {
      var K = { utf8: { stringToBytes: function(z) {
        return K.bin.stringToBytes(unescape(encodeURIComponent(z)));
      }, bytesToString: function(z) {
        return decodeURIComponent(escape(K.bin.bytesToString(z)));
      } }, bin: { stringToBytes: function(z) {
        for (var j = [], I = 0; I < z.length; I++)
          j.push(255 & z.charCodeAt(I));
        return j;
      }, bytesToString: function(z) {
        for (var j = [], I = 0; I < z.length; I++)
          j.push(String.fromCharCode(z[I]));
        return j.join("");
      } } };
      ot.exports = K;
    }, 332: (ot, K, z) => {
      var j = typeof globalThis < "u" && globalThis || typeof self < "u" && self || z.g !== void 0 && z.g, I = function() {
        function ft() {
          this.fetch = !1, this.DOMException = j.DOMException;
        }
        return ft.prototype = j, new ft();
      }();
      (function(ft) {
        (function(W) {
          var C = ft !== void 0 && ft || typeof self < "u" && self || C !== void 0 && C, nt = "URLSearchParams" in C, k = "Symbol" in C && "iterator" in Symbol, yt = "FileReader" in C && "Blob" in C && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(), y = "FormData" in C, m = "ArrayBuffer" in C;
          if (m)
            var w = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], g = ArrayBuffer.isView || function(h) {
              return h && w.indexOf(Object.prototype.toString.call(h)) > -1;
            };
          function E(h) {
            if (typeof h != "string" && (h = String(h)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(h) || h === "")
              throw new TypeError('Invalid character in header field name: "' + h + '"');
            return h.toLowerCase();
          }
          function dt(h) {
            return typeof h != "string" && (h = String(h)), h;
          }
          function mt(h) {
            var _ = { next: function() {
              var V = h.shift();
              return { done: V === void 0, value: V };
            } };
            return k && (_[Symbol.iterator] = function() {
              return _;
            }), _;
          }
          function U(h) {
            this.map = {}, h instanceof U ? h.forEach(function(_, V) {
              this.append(V, _);
            }, this) : Array.isArray(h) ? h.forEach(function(_) {
              this.append(_[0], _[1]);
            }, this) : h && Object.getOwnPropertyNames(h).forEach(function(_) {
              this.append(_, h[_]);
            }, this);
          }
          function tt(h) {
            if (h.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            h.bodyUsed = !0;
          }
          function Lt(h) {
            return new Promise(function(_, V) {
              h.onload = function() {
                _(h.result);
              }, h.onerror = function() {
                V(h.error);
              };
            });
          }
          function ee(h) {
            var _ = new FileReader(), V = Lt(_);
            return _.readAsArrayBuffer(h), V;
          }
          function Rt(h) {
            if (h.slice)
              return h.slice(0);
            var _ = new Uint8Array(h.byteLength);
            return _.set(new Uint8Array(h)), _.buffer;
          }
          function zt() {
            return this.bodyUsed = !1, this._initBody = function(h) {
              var _;
              this.bodyUsed = this.bodyUsed, this._bodyInit = h, h ? typeof h == "string" ? this._bodyText = h : yt && Blob.prototype.isPrototypeOf(h) ? this._bodyBlob = h : y && FormData.prototype.isPrototypeOf(h) ? this._bodyFormData = h : nt && URLSearchParams.prototype.isPrototypeOf(h) ? this._bodyText = h.toString() : m && yt && (_ = h) && DataView.prototype.isPrototypeOf(_) ? (this._bodyArrayBuffer = Rt(h.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : m && (ArrayBuffer.prototype.isPrototypeOf(h) || g(h)) ? this._bodyArrayBuffer = Rt(h) : this._bodyText = h = Object.prototype.toString.call(h) : this._bodyText = "", this.headers.get("content-type") || (typeof h == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : nt && URLSearchParams.prototype.isPrototypeOf(h) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
            }, yt && (this.blob = function() {
              var h = tt(this);
              if (h)
                return h;
              if (this._bodyBlob)
                return Promise.resolve(this._bodyBlob);
              if (this._bodyArrayBuffer)
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              if (this._bodyFormData)
                throw new Error("could not read FormData body as blob");
              return Promise.resolve(new Blob([this._bodyText]));
            }, this.arrayBuffer = function() {
              return this._bodyArrayBuffer ? tt(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer)) : this.blob().then(ee);
            }), this.text = function() {
              var h, _, V, bt = tt(this);
              if (bt)
                return bt;
              if (this._bodyBlob)
                return h = this._bodyBlob, V = Lt(_ = new FileReader()), _.readAsText(h), V;
              if (this._bodyArrayBuffer)
                return Promise.resolve(function(st) {
                  for (var X = new Uint8Array(st), Wt = new Array(X.length), vt = 0; vt < X.length; vt++)
                    Wt[vt] = String.fromCharCode(X[vt]);
                  return Wt.join("");
                }(this._bodyArrayBuffer));
              if (this._bodyFormData)
                throw new Error("could not read FormData body as text");
              return Promise.resolve(this._bodyText);
            }, y && (this.formData = function() {
              return this.text().then(Pt);
            }), this.json = function() {
              return this.text().then(JSON.parse);
            }, this;
          }
          U.prototype.append = function(h, _) {
            h = E(h), _ = dt(_);
            var V = this.map[h];
            this.map[h] = V ? V + ", " + _ : _;
          }, U.prototype.delete = function(h) {
            delete this.map[E(h)];
          }, U.prototype.get = function(h) {
            return h = E(h), this.has(h) ? this.map[h] : null;
          }, U.prototype.has = function(h) {
            return this.map.hasOwnProperty(E(h));
          }, U.prototype.set = function(h, _) {
            this.map[E(h)] = dt(_);
          }, U.prototype.forEach = function(h, _) {
            for (var V in this.map)
              this.map.hasOwnProperty(V) && h.call(_, this.map[V], V, this);
          }, U.prototype.keys = function() {
            var h = [];
            return this.forEach(function(_, V) {
              h.push(V);
            }), mt(h);
          }, U.prototype.values = function() {
            var h = [];
            return this.forEach(function(_) {
              h.push(_);
            }), mt(h);
          }, U.prototype.entries = function() {
            var h = [];
            return this.forEach(function(_, V) {
              h.push([V, _]);
            }), mt(h);
          }, k && (U.prototype[Symbol.iterator] = U.prototype.entries);
          var qt = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
          function Ft(h, _) {
            if (!(this instanceof Ft))
              throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            var V, bt, st = (_ = _ || {}).body;
            if (h instanceof Ft) {
              if (h.bodyUsed)
                throw new TypeError("Already read");
              this.url = h.url, this.credentials = h.credentials, _.headers || (this.headers = new U(h.headers)), this.method = h.method, this.mode = h.mode, this.signal = h.signal, st || h._bodyInit == null || (st = h._bodyInit, h.bodyUsed = !0);
            } else
              this.url = String(h);
            if (this.credentials = _.credentials || this.credentials || "same-origin", !_.headers && this.headers || (this.headers = new U(_.headers)), this.method = (bt = (V = _.method || this.method || "GET").toUpperCase(), qt.indexOf(bt) > -1 ? bt : V), this.mode = _.mode || this.mode || null, this.signal = _.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && st)
              throw new TypeError("Body not allowed for GET or HEAD requests");
            if (this._initBody(st), !(this.method !== "GET" && this.method !== "HEAD" || _.cache !== "no-store" && _.cache !== "no-cache")) {
              var X = /([?&])_=[^&]*/;
              X.test(this.url) ? this.url = this.url.replace(X, "$1_=" + (/* @__PURE__ */ new Date()).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
          function Pt(h) {
            var _ = new FormData();
            return h.trim().split("&").forEach(function(V) {
              if (V) {
                var bt = V.split("="), st = bt.shift().replace(/\+/g, " "), X = bt.join("=").replace(/\+/g, " ");
                _.append(decodeURIComponent(st), decodeURIComponent(X));
              }
            }), _;
          }
          function Et(h, _) {
            if (!(this instanceof Et))
              throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            _ || (_ = {}), this.type = "default", this.status = _.status === void 0 ? 200 : _.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = _.statusText === void 0 ? "" : "" + _.statusText, this.headers = new U(_.headers), this.url = _.url || "", this._initBody(h);
          }
          Ft.prototype.clone = function() {
            return new Ft(this, { body: this._bodyInit });
          }, zt.call(Ft.prototype), zt.call(Et.prototype), Et.prototype.clone = function() {
            return new Et(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new U(this.headers), url: this.url });
          }, Et.error = function() {
            var h = new Et(null, { status: 0, statusText: "" });
            return h.type = "error", h;
          };
          var oe = [301, 302, 303, 307, 308];
          Et.redirect = function(h, _) {
            if (oe.indexOf(_) === -1)
              throw new RangeError("Invalid status code");
            return new Et(null, { status: _, headers: { location: h } });
          }, W.DOMException = C.DOMException;
          try {
            new W.DOMException();
          } catch {
            W.DOMException = function(_, V) {
              this.message = _, this.name = V;
              var bt = Error(_);
              this.stack = bt.stack;
            }, W.DOMException.prototype = Object.create(Error.prototype), W.DOMException.prototype.constructor = W.DOMException;
          }
          function Zt(h, _) {
            return new Promise(function(V, bt) {
              var st = new Ft(h, _);
              if (st.signal && st.signal.aborted)
                return bt(new W.DOMException("Aborted", "AbortError"));
              var X = new XMLHttpRequest();
              function Wt() {
                X.abort();
              }
              X.onload = function() {
                var vt, Mt, re = { status: X.status, statusText: X.statusText, headers: (vt = X.getAllResponseHeaders() || "", Mt = new U(), vt.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(Dt) {
                  return Dt.indexOf(`
`) === 0 ? Dt.substr(1, Dt.length) : Dt;
                }).forEach(function(Dt) {
                  var ae = Dt.split(":"), F = ae.shift().trim();
                  if (F) {
                    var l = ae.join(":").trim();
                    Mt.append(F, l);
                  }
                }), Mt) };
                re.url = "responseURL" in X ? X.responseURL : re.headers.get("X-Request-URL");
                var ue = "response" in X ? X.response : X.responseText;
                setTimeout(function() {
                  V(new Et(ue, re));
                }, 0);
              }, X.onerror = function() {
                setTimeout(function() {
                  bt(new TypeError("Network request failed"));
                }, 0);
              }, X.ontimeout = function() {
                setTimeout(function() {
                  bt(new TypeError("Network request failed"));
                }, 0);
              }, X.onabort = function() {
                setTimeout(function() {
                  bt(new W.DOMException("Aborted", "AbortError"));
                }, 0);
              }, X.open(st.method, function(vt) {
                try {
                  return vt === "" && C.location.href ? C.location.href : vt;
                } catch {
                  return vt;
                }
              }(st.url), !0), st.credentials === "include" ? X.withCredentials = !0 : st.credentials === "omit" && (X.withCredentials = !1), "responseType" in X && (yt ? X.responseType = "blob" : m && st.headers.get("Content-Type") && st.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (X.responseType = "arraybuffer")), !_ || typeof _.headers != "object" || _.headers instanceof U ? st.headers.forEach(function(vt, Mt) {
                X.setRequestHeader(Mt, vt);
              }) : Object.getOwnPropertyNames(_.headers).forEach(function(vt) {
                X.setRequestHeader(vt, dt(_.headers[vt]));
              }), st.signal && (st.signal.addEventListener("abort", Wt), X.onreadystatechange = function() {
                X.readyState === 4 && st.signal.removeEventListener("abort", Wt);
              }), X.send(st._bodyInit === void 0 ? null : st._bodyInit);
            });
          }
          Zt.polyfill = !0, C.fetch || (C.fetch = Zt, C.Headers = U, C.Request = Ft, C.Response = Et), W.Headers = U, W.Request = Ft, W.Response = Et, W.fetch = Zt;
        })({});
      })(I), I.fetch.ponyfill = !0, delete I.fetch.polyfill;
      var M = j.fetch ? j : I;
      (K = M.fetch).default = M.fetch, K.fetch = M.fetch, K.Headers = M.Headers, K.Request = M.Request, K.Response = M.Response, ot.exports = K;
    }, 888: (ot) => {
      var K, z;
      K = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", z = { rotl: function(j, I) {
        return j << I | j >>> 32 - I;
      }, rotr: function(j, I) {
        return j << 32 - I | j >>> I;
      }, endian: function(j) {
        if (j.constructor == Number)
          return 16711935 & z.rotl(j, 8) | 4278255360 & z.rotl(j, 24);
        for (var I = 0; I < j.length; I++)
          j[I] = z.endian(j[I]);
        return j;
      }, randomBytes: function(j) {
        for (var I = []; j > 0; j--)
          I.push(Math.floor(256 * Math.random()));
        return I;
      }, bytesToWords: function(j) {
        for (var I = [], M = 0, ft = 0; M < j.length; M++, ft += 8)
          I[ft >>> 5] |= j[M] << 24 - ft % 32;
        return I;
      }, wordsToBytes: function(j) {
        for (var I = [], M = 0; M < 32 * j.length; M += 8)
          I.push(j[M >>> 5] >>> 24 - M % 32 & 255);
        return I;
      }, bytesToHex: function(j) {
        for (var I = [], M = 0; M < j.length; M++)
          I.push((j[M] >>> 4).toString(16)), I.push((15 & j[M]).toString(16));
        return I.join("");
      }, hexToBytes: function(j) {
        for (var I = [], M = 0; M < j.length; M += 2)
          I.push(parseInt(j.substr(M, 2), 16));
        return I;
      }, bytesToBase64: function(j) {
        for (var I = [], M = 0; M < j.length; M += 3)
          for (var ft = j[M] << 16 | j[M + 1] << 8 | j[M + 2], W = 0; W < 4; W++)
            8 * M + 6 * W <= 8 * j.length ? I.push(K.charAt(ft >>> 6 * (3 - W) & 63)) : I.push("=");
        return I.join("");
      }, base64ToBytes: function(j) {
        j = j.replace(/[^A-Z0-9+\/]/gi, "");
        for (var I = [], M = 0, ft = 0; M < j.length; ft = ++M % 4)
          ft != 0 && I.push((K.indexOf(j.charAt(M - 1)) & Math.pow(2, -2 * ft + 8) - 1) << 2 * ft | K.indexOf(j.charAt(M)) >>> 6 - 2 * ft);
        return I;
      } }, ot.exports = z;
    }, 792: (ot) => {
      function K(z) {
        return !!z.constructor && typeof z.constructor.isBuffer == "function" && z.constructor.isBuffer(z);
      }
      ot.exports = function(z) {
        return z != null && (K(z) || function(j) {
          return typeof j.readFloatLE == "function" && typeof j.slice == "function" && K(j.slice(0, 0));
        }(z) || !!z._isBuffer);
      };
    }, 752: (ot, K, z) => {
      var j, I, M, ft, W;
      j = z(888), I = z(260).utf8, M = z(792), ft = z(260).bin, (W = function(C, nt) {
        C.constructor == String ? C = nt && nt.encoding === "binary" ? ft.stringToBytes(C) : I.stringToBytes(C) : M(C) ? C = Array.prototype.slice.call(C, 0) : Array.isArray(C) || C.constructor === Uint8Array || (C = C.toString());
        for (var k = j.bytesToWords(C), yt = 8 * C.length, y = 1732584193, m = -271733879, w = -1732584194, g = 271733878, E = 0; E < k.length; E++)
          k[E] = 16711935 & (k[E] << 8 | k[E] >>> 24) | 4278255360 & (k[E] << 24 | k[E] >>> 8);
        k[yt >>> 5] |= 128 << yt % 32, k[14 + (yt + 64 >>> 9 << 4)] = yt;
        var dt = W._ff, mt = W._gg, U = W._hh, tt = W._ii;
        for (E = 0; E < k.length; E += 16) {
          var Lt = y, ee = m, Rt = w, zt = g;
          y = dt(y, m, w, g, k[E + 0], 7, -680876936), g = dt(g, y, m, w, k[E + 1], 12, -389564586), w = dt(w, g, y, m, k[E + 2], 17, 606105819), m = dt(m, w, g, y, k[E + 3], 22, -1044525330), y = dt(y, m, w, g, k[E + 4], 7, -176418897), g = dt(g, y, m, w, k[E + 5], 12, 1200080426), w = dt(w, g, y, m, k[E + 6], 17, -1473231341), m = dt(m, w, g, y, k[E + 7], 22, -45705983), y = dt(y, m, w, g, k[E + 8], 7, 1770035416), g = dt(g, y, m, w, k[E + 9], 12, -1958414417), w = dt(w, g, y, m, k[E + 10], 17, -42063), m = dt(m, w, g, y, k[E + 11], 22, -1990404162), y = dt(y, m, w, g, k[E + 12], 7, 1804603682), g = dt(g, y, m, w, k[E + 13], 12, -40341101), w = dt(w, g, y, m, k[E + 14], 17, -1502002290), y = mt(y, m = dt(m, w, g, y, k[E + 15], 22, 1236535329), w, g, k[E + 1], 5, -165796510), g = mt(g, y, m, w, k[E + 6], 9, -1069501632), w = mt(w, g, y, m, k[E + 11], 14, 643717713), m = mt(m, w, g, y, k[E + 0], 20, -373897302), y = mt(y, m, w, g, k[E + 5], 5, -701558691), g = mt(g, y, m, w, k[E + 10], 9, 38016083), w = mt(w, g, y, m, k[E + 15], 14, -660478335), m = mt(m, w, g, y, k[E + 4], 20, -405537848), y = mt(y, m, w, g, k[E + 9], 5, 568446438), g = mt(g, y, m, w, k[E + 14], 9, -1019803690), w = mt(w, g, y, m, k[E + 3], 14, -187363961), m = mt(m, w, g, y, k[E + 8], 20, 1163531501), y = mt(y, m, w, g, k[E + 13], 5, -1444681467), g = mt(g, y, m, w, k[E + 2], 9, -51403784), w = mt(w, g, y, m, k[E + 7], 14, 1735328473), y = U(y, m = mt(m, w, g, y, k[E + 12], 20, -1926607734), w, g, k[E + 5], 4, -378558), g = U(g, y, m, w, k[E + 8], 11, -2022574463), w = U(w, g, y, m, k[E + 11], 16, 1839030562), m = U(m, w, g, y, k[E + 14], 23, -35309556), y = U(y, m, w, g, k[E + 1], 4, -1530992060), g = U(g, y, m, w, k[E + 4], 11, 1272893353), w = U(w, g, y, m, k[E + 7], 16, -155497632), m = U(m, w, g, y, k[E + 10], 23, -1094730640), y = U(y, m, w, g, k[E + 13], 4, 681279174), g = U(g, y, m, w, k[E + 0], 11, -358537222), w = U(w, g, y, m, k[E + 3], 16, -722521979), m = U(m, w, g, y, k[E + 6], 23, 76029189), y = U(y, m, w, g, k[E + 9], 4, -640364487), g = U(g, y, m, w, k[E + 12], 11, -421815835), w = U(w, g, y, m, k[E + 15], 16, 530742520), y = tt(y, m = U(m, w, g, y, k[E + 2], 23, -995338651), w, g, k[E + 0], 6, -198630844), g = tt(g, y, m, w, k[E + 7], 10, 1126891415), w = tt(w, g, y, m, k[E + 14], 15, -1416354905), m = tt(m, w, g, y, k[E + 5], 21, -57434055), y = tt(y, m, w, g, k[E + 12], 6, 1700485571), g = tt(g, y, m, w, k[E + 3], 10, -1894986606), w = tt(w, g, y, m, k[E + 10], 15, -1051523), m = tt(m, w, g, y, k[E + 1], 21, -2054922799), y = tt(y, m, w, g, k[E + 8], 6, 1873313359), g = tt(g, y, m, w, k[E + 15], 10, -30611744), w = tt(w, g, y, m, k[E + 6], 15, -1560198380), m = tt(m, w, g, y, k[E + 13], 21, 1309151649), y = tt(y, m, w, g, k[E + 4], 6, -145523070), g = tt(g, y, m, w, k[E + 11], 10, -1120210379), w = tt(w, g, y, m, k[E + 2], 15, 718787259), m = tt(m, w, g, y, k[E + 9], 21, -343485551), y = y + Lt >>> 0, m = m + ee >>> 0, w = w + Rt >>> 0, g = g + zt >>> 0;
        }
        return j.endian([y, m, w, g]);
      })._ff = function(C, nt, k, yt, y, m, w) {
        var g = C + (nt & k | ~nt & yt) + (y >>> 0) + w;
        return (g << m | g >>> 32 - m) + nt;
      }, W._gg = function(C, nt, k, yt, y, m, w) {
        var g = C + (nt & yt | k & ~yt) + (y >>> 0) + w;
        return (g << m | g >>> 32 - m) + nt;
      }, W._hh = function(C, nt, k, yt, y, m, w) {
        var g = C + (nt ^ k ^ yt) + (y >>> 0) + w;
        return (g << m | g >>> 32 - m) + nt;
      }, W._ii = function(C, nt, k, yt, y, m, w) {
        var g = C + (k ^ (nt | ~yt)) + (y >>> 0) + w;
        return (g << m | g >>> 32 - m) + nt;
      }, W._blocksize = 16, W._digestsize = 16, ot.exports = function(C, nt) {
        if (C == null)
          throw new Error("Illegal argument " + C);
        var k = j.wordsToBytes(W(C, nt));
        return nt && nt.asBytes ? k : nt && nt.asString ? ft.bytesToString(k) : j.bytesToHex(k);
      };
    } }, pe = {};
    function At(ot) {
      var K = pe[ot];
      if (K !== void 0)
        return K.exports;
      var z = pe[ot] = { exports: {} };
      return Ee[ot].call(z.exports, z, z.exports, At), z.exports;
    }
    At.n = (ot) => {
      var K = ot && ot.__esModule ? () => ot.default : () => ot;
      return At.d(K, { a: K }), K;
    }, At.d = (ot, K) => {
      for (var z in K)
        At.o(K, z) && !At.o(ot, z) && Object.defineProperty(ot, z, { enumerable: !0, get: K[z] });
    }, At.g = function() {
      if (typeof globalThis == "object")
        return globalThis;
      try {
        return this || new Function("return this")();
      } catch {
        if (typeof window == "object")
          return window;
      }
    }(), At.o = (ot, K) => Object.prototype.hasOwnProperty.call(ot, K), At.r = (ot) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(ot, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(ot, "__esModule", { value: !0 });
    };
    var ye = {};
    return (() => {
      At.r(ye), At.d(ye, { FETCHING_LOCALES: () => Lt, FETCHING_TRANSLATIONS: () => dt, LOCALES_FETCHED: () => ee, LOCALES_FETCH_FAILED: () => Rt, LOCALE_CHANGED: () => tt, MessageFormatRenderer: () => re, PseudoTranslationPolicy: () => X, SourceErrorPolicy: () => vt, SourceStringPolicy: () => Wt, TRANSLATIONS_FETCHED: () => mt, TRANSLATIONS_FETCH_FAILED: () => U, ThrowErrorPolicy: () => Mt, createNativeInstance: () => ue, escape: () => m, explodePlurals: () => h, generateHashedKey: () => y, generateKey: () => yt, implodePlurals: () => _, isPluralized: () => V, isString: () => w, normalizeLocale: () => g, offEvent: () => Ft, onEvent: () => qt, sendEvent: () => Pt, sleep: () => E, t: () => ae, tx: () => Dt });
      var ot = At(332), K = At.n(ot);
      class z {
        constructor() {
          this.translationsByLocale = {};
        }
        update(l, v) {
          const O = this.translationsByLocale[l] || {};
          this.translationsByLocale[l] = { ...O, ...v };
        }
        getTranslations(l) {
          return this.translationsByLocale[l] || {};
        }
        hasTranslations(l) {
          return !!this.translationsByLocale[l];
        }
        isStale(l) {
          return !this.hasTranslations(l);
        }
        get(l, v) {
          return this.getTranslations(v)[l] || "";
        }
      }
      class j {
        handle(l, v, O, B) {
          return v;
        }
      }
      class I {
        handle(l, v) {
          return l;
        }
      }
      var M = At(180), ft = At.n(M);
      const W = {};
      class C {
        render(l, v, O) {
          const B = (v || "").split("_")[0];
          if (!W[B])
            try {
              W[B] = new (ft())(B, { strictPluralKeys: !1 });
            } catch {
              W[B] = new (ft())("*", { strictPluralKeys: !1 });
            }
          return W[B].compile(l)(O);
        }
      }
      var nt = At(752), k = At.n(nt);
      function yt(F) {
        let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return l._key ? l._key : l._context ? `${F}::${l._context}` : `${F}`;
      }
      function y(F) {
        let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (l._key)
          return l._key;
        let v = "";
        return l._context && (v = l._context, v = v.replace(/,/g, ":")), k()(`5:${F}:${v}`);
      }
      function m(F) {
        return F.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      }
      function w(F) {
        return Object.prototype.toString.call(F) === "[object String]";
      }
      function g(F) {
        const l = F.split("-");
        let v;
        return v = l.length === 1 ? F : [l[0], l[1].toUpperCase()].join("_"), v;
      }
      function E(F) {
        return new Promise((l) => {
          setTimeout(() => {
            l();
          }, F);
        });
      }
      const dt = "FETCHING_TRANSLATIONS", mt = "TRANSLATIONS_FETCHED", U = "TRANSLATIONS_FETCH_FAILED", tt = "LOCALE_CHANGED", Lt = "FETCHING_LOCALES", ee = "LOCALES_FETCHED", Rt = "LOCALES_FETCH_FAILED", zt = {};
      function qt(F, l) {
        zt[F] = zt[F] || [], zt[F].push(l);
      }
      function Ft(F, l) {
        const v = zt[F] || [], O = v.indexOf(l);
        O !== -1 && v.splice(O, 1);
      }
      function Pt(F, l, v) {
        (zt[F] || []).forEach((O) => {
          O(l, v);
        });
      }
      const Et = ["zero", "one", "two", "few", "many", "other"];
      function oe(F) {
        const l = F.indexOf("{");
        if (l === -1)
          return [null, null];
        let v = F.substring(0, l).trim();
        if (v[0] === "=") {
          if (v = v.substring(1), Number.isNaN(parseInt(v, 10)) || parseInt(v, 10) !== parseFloat(v))
            return [null, null];
          if (v = parseInt(v, 10), v = Et[v], v === void 0)
            return [null, null];
        } else if (Et.indexOf(v) === -1)
          return [null, null];
        return [v, F.substring(l)];
      }
      function Zt(F) {
        let [l, v] = [0, !1], O = 0;
        for (; O < F.length; ) {
          const B = F[O];
          if (B === "'") {
            const H = F[O + 1];
            H === "'" ? O += 1 : v ? v = !1 : H !== "{" && H !== "}" || (v = !0);
          } else if (B === "{")
            v || (l += 1);
          else if (B === "}" && (v || (l -= 1), l === 0))
            return [F.substring(1, O), F.substring(O + 1).trim()];
          O += 1;
        }
        return [null, null];
      }
      function h(F) {
        const l = [null, { other: F }];
        let [v, O] = function(wt) {
          if (!(wt.length > 1 && wt[0] === "{" && wt[wt.length - 1] === "}"))
            return [null, null];
          const xt = wt.indexOf(",");
          if (xt === -1)
            return [null, null];
          const $t = wt.indexOf(",", xt + 1);
          if ($t === -1)
            return [null, null];
          const Tt = wt.substring(1, xt).trim(), ce = wt.substring(xt + 1, $t).trim();
          return /^[\w_]+$/.test(Tt) && ce === "plural" ? [Tt, wt.substring($t + 1, wt.length - 1).trim()] : [null, null];
        }(F);
        if (v == null)
          return l;
        const B = {};
        let H, pt;
        if ([H, O] = oe(O), H == null || ([pt, O] = Zt(O.trim()), pt == null))
          return l;
        for (B[H] = pt; O.trim(); ) {
          if ([H, O] = oe(O.trim()), H == null || ([pt, O] = Zt(O.trim()), pt == null))
            return l;
          B[H] = pt;
        }
        return (Object.keys(B).length !== 1 || "other" in B) && "one" in B && "other" in B ? [v, B] : l;
      }
      function _(F) {
        const l = [`{${arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "???"}, plural,`];
        for (const v of Et)
          if (v in F) {
            const O = F[v];
            l.push(` ${v} {${O}}`);
          }
        return l.push("}"), l.join("");
      }
      function V(F) {
        const l = h(F)[1];
        return Object.keys(l).length > 1;
      }
      class bt {
        constructor() {
          this.cdsHost = "https://cds.svc.transifex.net", this.token = "", this.secret = "", this.filterTags = "", this.filterStatus = "", this.fetchTimeout = 0, this.fetchInterval = 250, this.cache = new z(), this.missingPolicy = new I(), this.errorPolicy = new j(), this.stringRenderer = new C(), this.currentLocale = "", this.locales = [], this.languages = [], this.childInstances = [];
        }
        init(l) {
          const v = this;
          ["cdsHost", "token", "secret", "cache", "filterTags", "filterStatus", "fetchTimeout", "fetchInterval", "missingPolicy", "errorPolicy", "stringRenderer", "currentLocale"].forEach((O) => {
            l[O] !== void 0 && (v[O] = l[O]);
          }), this.fetchedTags = {};
        }
        translate(l, v) {
          return this.translateLocale(this.currentLocale, l, v);
        }
        translateLocale(l, v, O) {
          try {
            let B = this.cache.get(yt(v, O), l);
            B || (B = this.cache.get(y(v, O), l)), B && B.startsWith("{???") && V(v) && (B = `{${v.substring(1, v.indexOf(",")).trim()}${B.substring(4)}`);
            let H = !1;
            if (B || (H = !0, B = v), O && O._escapeVars) {
              const pt = {};
              Object.keys(O).forEach((wt) => {
                const xt = O[wt];
                pt[wt] = w(xt) ? m(xt) : xt;
              }), B = this.stringRenderer.render(B, l, pt);
            } else
              B = this.stringRenderer.render(B, l, O);
            return H && l && (B = this.missingPolicy.handle(B, l)), w(B) || (B = `${B}`), B;
          } catch (B) {
            return this.errorPolicy.handle(B, `${v}`, l, O);
          }
        }
        async fetchTranslations(l) {
          let v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          const O = v.filterTags || this.filterTags;
          if (!v.refresh && !this.cache.isStale(l) && (!O && this.cache.hasTranslations(l) || O && (this.fetchedTags[l] || []).indexOf(O) !== -1))
            return;
          O && (l in this.fetchedTags || (this.fetchedTags[l] = []), this.fetchedTags[l].indexOf(O) === -1 && this.fetchedTags[l].push(O));
          const B = (H) => (Pt(U, { localeCode: l, filterTags: O }, this), H);
          try {
            let H;
            Pt(dt, { localeCode: l, filterTags: O }, this);
            let pt = 202;
            const wt = Date.now();
            for (; pt === 202; ) {
              let $t = `${this.cdsHost}/content/${l}`;
              const Tt = [];
              if (O && Tt.push(`filter[tags]=${O}`), this.filterStatus && Tt.push(`filter[status]=${this.filterStatus}`), Tt.length && ($t = `${$t}?${Tt.join("&")}`), H = await K()($t, { method: "GET", headers: { Authorization: `Bearer ${this.token}`, "Accept-version": "v2", "X-NATIVE-SDK": "txjs/browser/7.1.0" }, signal: this.fetchTimeout > 0 ? AbortSignal.timeout(this.fetchTimeout) : void 0 }), !H.ok)
                throw await this._fetchError(H);
              if (pt = H.status, this.fetchTimeout > 0 && Date.now() - wt >= this.fetchTimeout)
                throw B(new Error("Fetch translations timeout"));
              pt === 202 && this.fetchInterval > 0 && await E(this.fetchInterval);
            }
            const xt = await H.json();
            if (!xt || !xt.data)
              throw B(new Error("Could not fetch translations"));
            {
              const $t = {};
              Object.keys(xt.data).forEach((Tt) => {
                xt.data[Tt].string && ($t[Tt] = xt.data[Tt].string);
              }), this.cache.update(l, $t), Pt(mt, { localeCode: l, filterTags: O }, this);
            }
          } catch (H) {
            throw B(H);
          }
        }
        async invalidateCDS() {
          let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          if (!this.token)
            throw new Error("token is not defined");
          if (!this.secret)
            throw new Error("secret is not defined");
          const v = l.purge ? "purge" : "invalidate", O = await K()(`${this.cdsHost}/${v}`, { method: "POST", headers: { Authorization: `Bearer ${this.token}:${this.secret}`, "Accept-version": "v2", "Content-Type": "application/json;charset=utf-8", "X-NATIVE-SDK": "txjs/browser/7.1.0" } });
          if (!O.ok)
            throw await this._fetchError(O);
          return await O.json();
        }
        async pushSource(l) {
          let v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (!this.token)
            throw new Error("token is not defined");
          if (!this.secret)
            throw new Error("secret is not defined");
          const O = { Authorization: `Bearer ${this.token}:${this.secret}`, "Accept-version": "v2", "Content-Type": "application/json;charset=utf-8", "X-NATIVE-SDK": "txjs/browser/7.1.0" }, B = await K()(`${this.cdsHost}/content`, { method: "POST", headers: O, body: JSON.stringify({ data: l, meta: { purge: !!v.purge, override_tags: !!v.overrideTags, override_occurrences: !!v.overrideOccurrences } }) });
          if (!B.ok)
            throw await this._fetchError(B);
          const H = await B.json(), pt = `${this.cdsHost}${H.data.links.job}`;
          if (v.noWait)
            return { jobUrl: pt };
          let wt = { status: "" };
          do {
            await E(1500);
            const xt = await K()(pt, { method: "GET", headers: O });
            if (!xt.ok)
              throw await this._fetchError(xt);
            const $t = await xt.json(), { data: Tt } = $t;
            wt = { ...Tt.details || {}, errors: Tt.errors || [], status: Tt.status };
          } while (wt.status === "pending" || wt.status === "processing");
          return { jobUrl: pt, ...wt };
        }
        async getLocales() {
          if (!(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).refresh && this.locales.length > 0)
            return [...this.locales];
          if (!this.token)
            return [];
          const l = (v) => (Pt(Rt, null, this), v);
          try {
            let v;
            Pt(Lt, null, this);
            let O = 202;
            const B = Date.now();
            for (; O === 202; ) {
              if (v = await K()(`${this.cdsHost}/languages`, { method: "GET", headers: { Authorization: `Bearer ${this.token}`, "Accept-version": "v2", "X-NATIVE-SDK": "txjs/browser/7.1.0" }, signal: this.fetchTimeout > 0 ? AbortSignal.timeout(this.fetchTimeout) : void 0 }), !v.ok)
                throw await this._fetchError(v);
              if (O = v.status, this.fetchTimeout > 0 && Date.now() - B >= this.fetchTimeout)
                throw l(new Error("Get locales timeout"));
              O === 202 && this.fetchInterval > 0 && await E(this.fetchInterval);
            }
            const H = await v.json();
            if (!H || !H.data)
              throw l(new Error("Could not fetch languages"));
            this.languages = H.data, this.locales = this.languages.map((pt) => pt.code), Pt(ee, null, this);
          } catch (v) {
            throw l(v);
          }
          return [...this.locales];
        }
        getCurrentLocale() {
          return this.currentLocale;
        }
        isCurrent(l) {
          return l === this.currentLocale;
        }
        async setCurrentLocale(l) {
          if (this.isCurrent(l))
            await this._syncInstances(this.childInstances);
          else {
            if (!l)
              return this.currentLocale = "", await this._syncInstances(this.childInstances), void Pt(tt, this.currentLocale, this);
            await this.fetchTranslations(l), this.currentLocale = l, await this._syncInstances(this.childInstances), Pt(tt, l, this);
          }
        }
        async getLanguages() {
          let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return await this.getLocales(l), [...this.languages];
        }
        async controllerOf(l) {
          if (l === this)
            throw new Error("Cannot add self as instance");
          if (l.childInstances.indexOf(this) !== -1)
            throw new Error("Cycle reference error, instance is controller of this");
          return this.childInstances.push(l), await this._syncInstances([l]), l;
        }
        async _syncInstances(l) {
          const v = this.getCurrentLocale();
          if (v) {
            for (let O = 0; O < l.length; O++)
              if (l[O].getCurrentLocale() !== v)
                try {
                  await l[O].fetchTranslations(v);
                } catch {
                }
          }
          l.forEach((O) => {
            O.getCurrentLocale() !== v && (O.currentLocale = v, Pt(tt, v, O));
          });
        }
        async _fetchError(l) {
          try {
            const v = await l.text();
            return new Error(`HTTP ${l.status}: ${v}`);
          } catch {
            return new Error(`HTTP error ${l.status}`);
          }
        }
      }
      const st = { a: "ȧ", A: "Ȧ", b: "ƀ", B: "Ɓ", c: "ƈ", C: "Ƈ", d: "ḓ", D: "Ḓ", e: "ḗ", E: "Ḗ", f: "ƒ", F: "Ƒ", g: "ɠ", G: "Ɠ", h: "ħ", H: "Ħ", i: "ī", I: "Ī", j: "ĵ", J: "Ĵ", k: "ķ", K: "Ķ", l: "ŀ", L: "Ŀ", m: "ḿ", M: "Ḿ", n: "ƞ", N: "Ƞ", o: "ǿ", O: "Ǿ", p: "ƥ", P: "Ƥ", q: "ɋ", Q: "Ɋ", r: "ř", R: "Ř", s: "ş", S: "Ş", t: "ŧ", T: "Ŧ", v: "ṽ", V: "Ṽ", u: "ŭ", U: "Ŭ", w: "ẇ", W: "Ẇ", x: "ẋ", X: "Ẋ", y: "ẏ", Y: "Ẏ", z: "ẑ", Z: "Ẑ" }, X = class {
        handle(F, l) {
          return F.split(/__txnative__/).map((v) => {
            let O = "";
            for (let B = 0; B < v.length; B += 1) {
              const H = v.charAt(B);
              if (st[H]) {
                const pt = H.toLowerCase();
                O += pt === "a" || pt === "e" || pt === "o" || pt === "u" ? st[H] + st[H] : st[H];
              } else
                O += H;
            }
            return O;
          }).join("__txnative__");
        }
      }, Wt = I, vt = j, Mt = class {
        handle(F, l, v, O) {
          throw F || new Error(`Error translating "${l}"`);
        }
      }, re = C, ue = function(F) {
        const l = new bt();
        return l.t = l.translate.bind(l), F && l.init(F), l;
      }, Dt = new bt(), ae = Dt.translate.bind(Dt);
    })(), ye;
  })());
})($e);
var Dh = $e.exports;
export {
  Dh as b
};
